import { chipClasses, inputAdornmentClasses, inputLabelClasses, paperClasses, snackbarContentClasses, buttonClasses, svgIconClasses, tableRowClasses, createTheme, Card as Card$1, Button as Button$1, Chip as Chip$1, useTheme, Dialog as Dialog$1, Fab as Fab$1, IconButton as IconButton$1 } from '@mui/material';
import reduce from 'lodash/reduce';
import _merge from 'lodash/merge';
import _camelCase from 'lodash/camelCase';
import _isArray from 'lodash/isArray';
import fill from 'lodash/fill';
import { useState } from 'react';
import { jsx } from 'react/jsx-runtime';
import { animated, useSpring, config } from '@react-spring/web';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/material/styles';
import { StaticDatePicker, StaticTimePicker } from '@mui/x-date-pickers';

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

var token = {
	dimension: {
		scale: {
			value: "2",
			type: "dimension"
		},
		xs: {
			value: "4",
			type: "dimension"
		},
		sm: {
			value: "{dimension.xs} * {dimension.scale}",
			type: "dimension"
		},
		md: {
			value: "{dimension.sm} * {dimension.scale}",
			type: "dimension"
		},
		lg: {
			value: "{dimension.md} * {dimension.scale}",
			type: "dimension"
		},
		xl: {
			value: "{dimension.lg} * {dimension.scale}",
			type: "dimension"
		}
	},
	spacing: {
		xs: {
			value: "{dimension.xs}",
			type: "spacing"
		},
		sm: {
			value: "{dimension.sm}",
			type: "spacing"
		},
		md: {
			value: "{dimension.md}",
			type: "spacing"
		},
		lg: {
			value: "{dimension.lg}",
			type: "spacing"
		},
		xl: {
			value: "{dimension.xl}",
			type: "spacing"
		},
		"multi-value": {
			value: "{dimension.sm} {dimension.xl}",
			type: "spacing",
			description: "You can have multiple values in a single spacing token. Read more on these: https://docs.tokens.studio/available-tokens/spacing-tokens#multi-value-spacing-tokens"
		}
	},
	borderRadius: {
		sm: {
			value: "4",
			type: "borderRadius"
		},
		lg: {
			value: "8",
			type: "borderRadius"
		},
		xl: {
			value: "16",
			type: "borderRadius"
		},
		"multi-value": {
			value: "{borderRadius.sm} {borderRadius.lg}",
			type: "borderRadius",
			description: "You can have multiple values in a single radius token. Read more on these: https://docs.tokens.studio/available-tokens/border-radius-tokens#single--multiple-values"
		}
	},
	opacity: {
		low: {
			value: "10%",
			type: "opacity"
		},
		md: {
			value: "50%",
			type: "opacity"
		},
		high: {
			value: "90%",
			type: "opacity"
		}
	},
	fontFamilies: {
		heading: {
			value: "Inter",
			type: "fontFamilies"
		},
		body: {
			value: "Roboto",
			type: "fontFamilies"
		},
		inter: {
			value: "Inter",
			type: "fontFamilies"
		}
	},
	lineHeights: {
		"0": {
			value: "64",
			type: "lineHeights"
		},
		"1": {
			value: "52",
			type: "lineHeights"
		},
		"2": {
			value: "44",
			type: "lineHeights"
		},
		"3": {
			value: "40",
			type: "lineHeights"
		},
		"4": {
			value: "36",
			type: "lineHeights"
		},
		"5": {
			value: "32",
			type: "lineHeights"
		},
		"6": {
			value: "28",
			type: "lineHeights"
		},
		"7": {
			value: "26",
			type: "lineHeights"
		},
		"8": {
			value: "20",
			type: "lineHeights"
		},
		"9": {
			value: "24",
			type: "lineHeights"
		},
		"10": {
			value: "16",
			type: "lineHeights"
		},
		heading: {
			value: "110%",
			type: "lineHeights"
		},
		body: {
			value: "140%",
			type: "lineHeights"
		}
	},
	letterSpacing: {
		"0": {
			value: "0%",
			type: "letterSpacing"
		},
		"default": {
			value: "0",
			type: "letterSpacing"
		},
		increased: {
			value: "150%",
			type: "letterSpacing"
		},
		decreased: {
			value: "-5%",
			type: "letterSpacing"
		}
	},
	paragraphSpacing: {
		"0": {
			value: "0",
			type: "paragraphSpacing"
		},
		h1: {
			value: "32",
			type: "paragraphSpacing"
		},
		h2: {
			value: "26",
			type: "paragraphSpacing"
		}
	},
	fontWeights: {
		headingRegular: {
			value: "Regular",
			type: "fontWeights"
		},
		headingBold: {
			value: "Bold",
			type: "fontWeights"
		},
		bodyRegular: {
			value: "Regular",
			type: "fontWeights"
		},
		bodyBold: {
			value: "Bold",
			type: "fontWeights"
		},
		"inter-0": {
			value: "Regular",
			type: "fontWeights"
		},
		"inter-1": {
			value: "Semi Bold",
			type: "fontWeights"
		},
		"inter-2": {
			value: "Bold",
			type: "fontWeights"
		}
	},
	fontSizes: {
		h1: {
			value: "{fontSizes.h2} * 1.25",
			type: "fontSizes"
		},
		h2: {
			value: "{fontSizes.h3} * 1.25",
			type: "fontSizes"
		},
		h3: {
			value: "{fontSizes.h4} * 1.25",
			type: "fontSizes"
		},
		h4: {
			value: "{fontSizes.h5} * 1.25",
			type: "fontSizes"
		},
		h5: {
			value: "{fontSizes.h6} * 1.25",
			type: "fontSizes"
		},
		h6: {
			value: "{fontSizes.body} * 1",
			type: "fontSizes"
		},
		body: {
			value: "16",
			type: "fontSizes"
		},
		sm: {
			value: "{fontSizes.body} * 0.85",
			type: "fontSizes"
		},
		xs: {
			value: "{fontSizes.body} * 0.65",
			type: "fontSizes"
		}
	},
	M3: {
		white: {
			value: "#ffffff",
			type: "color"
		},
		black: {
			value: "#000000",
			type: "color"
		},
		sys: {
			light: {
				selectedState: {
					value: "linear-gradient(138deg, #1d65e8 0%, #1d64e826 100%)",
					type: "color"
				},
				primary: {
					oldValue: "#1a5cd7",
					value: "#005ef9",
					type: "color"
				},
				onPrimary: {
					value: "#ffffff",
					type: "color"
				},
				primaryContainer: {
					oldValue: "#dfe9fc",
					value: "#dee9ff",
					type: "color"
				},
				onPrimaryContainer: {
					oldValue: "#040e21",
					value: "#000c2a",
					type: "color"
				},
				primaryFixed: {
					oldValue: "#dfe9fc",
					value: "#dee9ff",
					type: "color"
				},
				onPrimaryFixed: {
					oldValue: "#040e21",
					value: "#000c2a",
					type: "color"
				},
				primaryFixedDim: {
					oldValue: "#aec8f7",
					value: "#aac8ff",
					type: "color"
				},
				onPrimaryFixedVariant: {
					oldValue: "#113985",
					value: "#003494",
					type: "color"
				},
				secondary: {
					oldValue: "#68758f",
					value: "#673cff",
					type: "color"
				},
				onSecondary: {
					value: "#ffffff",
					type: "color"
				},
				secondaryContainer: {
					oldValue: "#d2d7e1",
					value: "#cec8ff",
					type: "color"
				},
				onSecondaryContainer: {
					oldValue: "#0b0b14",
					value: "#0c0030",
					type: "color"
				},
				secondaryFixed: {
					oldValue: "#e2e8f6",
					value: "#dddbff",
					type: "color"
				},
				onSecondaryFixed: {
					oldValue: "#0a0d14",
					value: "#0c0030",
					type: "color"
				},
				secondaryFixedDim: {
					oldValue: "#bdc6da",
					value: "#cec8ff",
					type: "color"
				},
				onSecondaryFixedVariant: {
					oldValue: "#2d3648",
					value: "#3a00a7",
					type: "color"
				},
				error: {
					oldValue: "#b3261e",
					value: "#bd0005",
					type: "color"
				},
				onError: {
					value: "#ffffff",
					type: "color"
				},
				errorContainer: {
					oldValue: "#f9dedc",
					value: "#ffdcd9",
					type: "color"
				},
				onErrorContainer: {
					oldValue: "#601410",
					value: "#490002",
					type: "color"
				},
				outline: {
					value: "#76a5ff",
					type: "color"
				},
				onBackground: {
					value: "#1d1b20",
					type: "color"
				},
				onSurface: {
					oldValue: "#13151c",
					value: "#070d1a",
					type: "color"
				},
				surfaceVariant: {
					value: "#e5e8ef",
					type: "color"
				},
				onSurfaceVariant: {
					oldValue: "#293650",
					value: "#405172",
					type: "color"
				},
				inverseSurface: {
					oldValue: "#1d2330",
					value: "#1a2337",
					type: "color"
				},
				inverseOnSurface: {
					oldValue: "#f2f3f7",
					value: "#f0f3ff",
					type: "color"
				},
				inversePrimary: {
					oldValue: "#aec8f7",
					value: "#aac8ff",
					type: "color"
				},
				shadow: {
					value: "#000000",
					type: "color"
				},
				surfaceTint: {
					value: "#1d64e8",
					type: "color"
				},
				outlineVariant: {
					value: "#96a3bd",
					type: "color"
				},
				scrim: {
					value: "#000000",
					type: "color"
				},
				surfaceContainerHighest: {
					value: "linear-gradient(180deg, #d4dbeb 0%, #dae2ef 100%)",
					type: "color"
				},
				surfaceContainerHigh: {
					value: "linear-gradient(180deg, #dbe2f1 0%, #dfe7f5 100%)",
					type: "color"
				},
				surfaceContainer: {
					value: "linear-gradient(180deg, #e9edf7 0%, #eef2fc 100%)",
					type: "color"
				},
				surfaceContainerLow: {
					value: "linear-gradient(180deg, #f3f6fa 0%, #f8fafe 100%)",
					type: "color"
				},
				surfaceContainerLowest: {
					value: "linear-gradient(180deg, #fbfbfd 0%, #fdfdff 100%)",
					type: "color"
				},
				surfaceBright: {
					value: "linear-gradient(180deg, #ffffff 13.54%, #f8fafe 100%)",
					type: "color"
				},
				surfaceDim: {
					value: "linear-gradient(180deg, #f8faff 0%, #f4f6ff 100%)",
					type: "color"
				},
				background: {
					value: "linear-gradient(180deg, #f8faff 0%, #f4f6ff 100%)",
					type: "color",
					description: "Gradient Background that sits behind all content"
				},
				headerContainer: {
					value: "linear-gradient(180deg, #fbfbfd 50%, #fdfdff00 100%)",
					type: "color"
				},
				primaryButtonCta: {
					value: "radial-gradient(108.98% 88.6% at 1.38% 64.58%, rgba(223, 233, 252, 0.11) 0%, rgba(236, 242, 253, 0.00) 100%), linear-gradient(268deg, #1982AF -3.23%, #005EF9 20.93%, #0042B6 102.21%)",
					type: "color"
				},
				outlinedButton: {
					value: "radial-gradient(281.64% 61.17% at 103.88% 50%, rgba(23, 229, 205, 0.04) 0%, rgba(64, 195, 203, 0.00) 72.4%), radial-gradient(68.74% 76.79% at 100% 90.63%, rgba(61, 122, 235, 0.20) 0%, rgba(61, 122, 235, 0.00) 100%)",
					type: "color"
				},
				cardHover: {
					value: "radial-gradient(73.2% 71.97% at 0% 0%, rgba(29, 100, 232, 0.70) 0%, rgba(29, 100, 232, 0.19) 42.19%, rgba(29, 100, 232, 0.00) 83.85%), radial-gradient(123.71% 123.49% at -2.26% -14.77%, rgba(29, 100, 232, 0.80) 0%, rgba(29, 100, 232, 0.25) 54.69%, rgba(29, 100, 232, 0.00) 100%), radial-gradient(242.87% 242.81% at -9.2% -71.21%, rgba(29, 241, 255, 0.40) 0%, rgba(29, 241, 255, 0.22) 28.13%, rgba(29, 241, 255, 0.13) 48.44%, rgba(29, 241, 255, 0.00) 84.38%)",
					type: "color"
				},
				surface: {
					value: "linear-gradient(0deg, rgba(29, 100, 232, 0.01) 0%, rgba(29, 100, 232, 0.01) 100%), linear-gradient(180deg, #FFF 0%, #FDFDFD 100%)",
					type: "color"
				},
				flatSurface: {
					value: "#dfe9fc",
					type: "color"
				}
			},
			dark: {
				selectedState: {
					value: "linear-gradient(138deg, #1d65e8 0%, #1d64e826 100%)",
					type: "color"
				},
				primary: {
					oldValue: "#5e90ef",
					value: "#2b75ff",
					type: "color"
				},
				onPrimary: {
					oldValue: "#081d42",
					value: "#001a4e",
					type: "color"
				},
				primaryContainer: {
					oldValue: "#dfe9fc",
					value: "#003494",
					type: "color"
				},
				onPrimaryContainer: {
					oldValue: "#1547a6",
					value: "#dee9ff",
					type: "color"
				},
				primaryFixed: {
					value: "#dfe9fc",
					type: "color"
				},
				onPrimaryFixed: {
					oldValue: "#040e21",
					value: "#000000",
					type: "color"
				},
				primaryFixedDim: {
					value: "#113985",
					type: "color"
				},
				onPrimaryFixedVariant: {
					oldValue: "#bed3f8",
					value: "#c4d9ff",
					type: "color"
				},
				secondary: {
					oldValue: "#bebae5",
					value: "#beb5ff",
					type: "color"
				},
				onSecondary: {
					oldValue: "#1d1a3d",
					value: "#210068",
					type: "color"
				},
				secondaryContainer: {
					oldValue: "#2e2d66",
					value: "#3a00a7",
					type: "color"
				},
				onSecondaryContainer: {
					oldValue: "#deddf2",
					value: "#dddbff",
					type: "color"
				},
				secondaryFixed: {
					oldValue: "#deddf2",
					value: "#dddbff",
					type: "color"
				},
				onSecondaryFixed: {
					oldValue: "#090914",
					value: "#0c0030",
					type: "color"
				},
				secondaryFixedDim: {
					oldValue: "#bebae5",
					value: "#beb5ff",
					type: "color"
				},
				onSecondaryFixedVariant: {
					oldValue: "#2e2d66",
					value: "#3a00a7",
					type: "color"
				},
				error: {
					oldValue: "#e46962",
					value: "#ffb1ae",
					type: "color"
				},
				onError: {
					oldValue: "#601410",
					value: "#680003",
					type: "color"
				},
				errorContainer: {
					oldValue: "#8c1d18",
					value: "#950006",
					type: "color"
				},
				onErrorContainer: {
					oldValue: "#f9dedc",
					value: "#ffdcd9",
					type: "color"
				},
				outline: {
					value: "#003494",
					type: "color"
				},
				onBackground: {
					value: "#e6e0e9",
					type: "color"
				},
				onSurface: {
					oldValue: "#f2f3f7",
					value: "#e2e8f6",
					type: "color"
				},
				surfaceVariant: {
					value: "#49454f",
					type: "color"
				},
				onSurfaceVariant: {
					oldValue: "#bdc6da",
					value: "#96a3bd",
					type: "color"
				},
				inverseSurface: {
					oldValue: "#1d2330",
					value: "#1a2337",
					type: "color"
				},
				inverseOnSurface: {
					value: "#f2f3f7",
					type: "color"
				},
				inversePrimary: {
					oldValue: "#aec8f7",
					value: "#0042b6",
					type: "color"
				},
				shadow: {
					value: "#000000",
					type: "color"
				},
				surfaceTint: {
					value: "#3d7aeb",
					type: "color"
				},
				outlineVariant: {
					value: "#293650",
					type: "color"
				},
				scrim: {
					value: "#000000",
					type: "color"
				},
				surfaceContainerHighest: {
					value: "linear-gradient(180deg, #0e1b35 0%, #12213d 100%)",
					type: "color"
				},
				surfaceContainerHigh: {
					value: "linear-gradient(180deg, #111e35 0%, #0d172c 100%)",
					type: "color"
				},
				surfaceContainer: {
					value: "linear-gradient(180deg, #0c1424 0%, #111b2d 100%)",
					type: "color"
				},
				surfaceContainerLow: {
					value: "linear-gradient(180deg, #0c1220 0%, #111929 100%)",
					type: "color"
				},
				surfaceContainerLowest: {
					value: "linear-gradient(180deg, #0c111b 0%, #101726 100%)",
					type: "color"
				},
				surfaceBright: {
					value: "linear-gradient(180deg, #111e35 0%, #0d172c 100%)",
					type: "color"
				},
				surfaceDim: {
					value: "linear-gradient(180deg, #0f141f 0%, #0a0d14 100%)",
					type: "color"
				},
				background: {
					value: "linear-gradient(180deg, #0d1421 0%, #0a0f1a 100%)",
					type: "color"
				},
				"outline(mobile)": {
					value: "linear-gradient(180deg, #3d7aeb80 0%, #3d7aeb29 100%)",
					type: "color"
				},
				headerContainer: {
					value: "linear-gradient(180deg, #0d121c 50%, #11182700 100%)",
					type: "color"
				},
				primaryButtonCta: {
					value: "radial-gradient(108.98% 88.6% at 1.38% 64.58%, rgba(223, 233, 252, 0.11) 0%, rgba(236, 242, 253, 0.00) 100%), linear-gradient(268deg, #1982AF -3.23%, #005EF9 20.93%, #0042B6 102.21%)",
					type: "color"
				},
				outlinedButton: {
					value: "radial-gradient(281.64% 61.17% at 103.88% 50%, rgba(23, 229, 205, 0.22) 0%, rgba(64, 195, 203, 0.00) 72.4%), radial-gradient(68.74% 76.79% at 100% 90.63%, rgba(29, 100, 232, 0.80) 0%, rgba(29, 100, 232, 0.00) 100%)",
					type: "color"
				},
				cardHover: {
					value: "radial-gradient(73.2% 71.97% at 0% 0%, rgba(29, 100, 232, 0.56) 0%, rgba(29, 100, 232, 0.15) 26.04%, rgba(29, 100, 232, 0.00) 70.31%), radial-gradient(123.71% 123.49% at -2.26% -14.77%, rgba(29, 100, 232, 0.54) 0%, rgba(29, 100, 232, 0.17) 34.38%, rgba(29, 100, 232, 0.00) 100%), radial-gradient(242.87% 242.81% at -9.2% -71.21%, rgba(29, 241, 255, 0.40) 0%, rgba(29, 241, 255, 0.22) 28.13%, rgba(29, 241, 255, 0.13) 62.5%, rgba(29, 241, 255, 0.00) 97.4%)",
					type: "color"
				},
				surface: {
					value: "#0a0b0f",
					type: "color"
				},
				flatSurface: {
					value: "linear-gradient(180deg, #090c14 0%, #0a0d15 100%)",
					type: "color"
				}
			},
			ref: {
				primary: {
					primary0: {
						value: "#000000",
						type: "color"
					},
					primary10: {
						oldValue: "#040e21",
						value: "#000c2a",
						type: "color"
					},
					primary15: {
						oldValue: "#061632",
						value: "#00133c",
						type: "color"
					},
					primary20: {
						oldValue: "#081d42",
						value: "#001a4e",
						type: "color"
					},
					primary25: {
						oldValue: "#0c2b63",
						value: "#002771",
						type: "color"
					},
					primary30: {
						oldValue: "#113985",
						value: "#003494",
						type: "color"
					},
					primary35: {
						oldValue: "#1547a6",
						value: "#0042b6",
						type: "color"
					},
					primary40: {
						oldValue: "#1956c7",
						value: "#0051d7",
						type: "color"
					},
					primary45: {
						oldValue: "#1a5cd7",
						value: "#0058e8",
						type: "color"
					},
					primary50: {
						oldValue: "#1d64e8",
						value: "#005ef9",
						type: "color"
					},
					primary60: {
						oldValue: "#3d7aeb",
						value: "#2b75ff",
						type: "color"
					},
					primary65: {
						oldValue: "#5e90ef",
						value: "#518dff",
						type: "color"
					},
					primary70: {
						oldValue: "#7ea6f2",
						value: "#76a5ff",
						type: "color"
					},
					primary75: {
						oldValue: "#9ebdf5",
						value: "#90b7ff",
						type: "color"
					},
					primary80: {
						oldValue: "#aec8f7",
						value: "#aac8ff",
						type: "color"
					},
					primary85: {
						oldValue: "#bed3f8",
						value: "#c4d9ff",
						type: "color"
					},
					primary90: {
						oldValue: "#dfe9fc",
						value: "#dee9ff",
						type: "color"
					},
					primary95: {
						oldValue: "#ecf2fd",
						value: "#ebf2ff",
						type: "color"
					},
					primary99: {
						value: "#f8fafe",
						type: "color"
					},
					primary100: {
						value: "#ffffff",
						type: "color"
					}
				},
				secondary: {
					secondary0: {
						value: "#000000",
						type: "color"
					},
					secondary10: {
						oldValue: "#090914",
						value: "#0c0030",
						type: "color"
					},
					secondary15: {
						oldValue: "#131228",
						value: "#17004c",
						type: "color"
					},
					secondary20: {
						oldValue: "#1d1a3d",
						value: "#210068",
						type: "color"
					},
					secondary25: {
						oldValue: "#262351",
						value: "#2e0088",
						type: "color"
					},
					secondary30: {
						oldValue: "#2e2d66",
						value: "#3a00a7",
						type: "color"
					},
					secondary35: {
						oldValue: "#38367a",
						value: "#4700c5",
						type: "color"
					},
					secondary40: {
						oldValue: "#413f8f",
						value: "#5300e3",
						type: "color"
					},
					secondary45: {
						oldValue: "#4b46a3",
						value: "#5d1ef1",
						type: "color"
					},
					secondary50: {
						oldValue: "#5551b7",
						value: "#673cff",
						type: "color"
					},
					secondary60: {
						oldValue: "#7975ca",
						value: "#7861ff",
						type: "color"
					},
					secondary65: {
						oldValue: "#8a87d1",
						value: "#8978ff",
						type: "color"
					},
					secondary70: {
						oldValue: "#9b98d8",
						value: "#998eff",
						type: "color"
					},
					secondary75: {
						oldValue: "#aca9de",
						value: "#aca2ff",
						type: "color"
					},
					secondary80: {
						oldValue: "#bebae5",
						value: "#beb5ff",
						type: "color"
					},
					secondary85: {
						oldValue: "#cecbeb",
						value: "#cec8ff",
						type: "color"
					},
					secondary90: {
						oldValue: "#deddf2",
						value: "#dddbff",
						type: "color"
					},
					secondary95: {
						oldValue: "#efeef8",
						value: "#efedff",
						type: "color"
					},
					secondary99: {
						value: "#f7f7fc",
						type: "color"
					},
					secondary100: {
						value: "#ffffff",
						type: "color"
					}
				},
				error: {
					error0: {
						value: "#000000",
						type: "color"
					},
					error10: {
						oldValue: "#410e0b",
						value: "#490002",
						type: "color"
					},
					error20: {
						oldValue: "#601410",
						value: "#680003",
						type: "color"
					},
					error30: {
						oldValue: "#8c1d18",
						value: "#950006",
						type: "color"
					},
					error40: {
						oldValue: "#b3261e",
						value: "#bd0005",
						type: "color"
					},
					error50: {
						oldValue: "#dc362e",
						value: "#ea0010",
						type: "color"
					},
					error60: {
						oldValue: "#e46962",
						value: "#ff4949",
						type: "color"
					},
					error70: {
						oldValue: "#ec928e",
						value: "#ff8582",
						type: "color"
					},
					error80: {
						oldValue: "#f2b8b5",
						value: "#ffb1ae",
						type: "color"
					},
					error90: {
						oldValue: "#f9dedc",
						value: "#ffdcd9",
						type: "color"
					},
					error95: {
						oldValue: "#fceeee",
						value: "#ffeded",
						type: "color"
					},
					error99: {
						value: "#fffbf9",
						type: "color"
					},
					error100: {
						value: "#ffffff",
						type: "color"
					}
				},
				neutral: {
					neutral0: {
						value: "#000000",
						type: "color"
					},
					neutral10: {
						oldValue: "#0a0d14",
						value: "#070d1a",
						type: "color"
					},
					neutral15: {
						oldValue: "#161b26",
						value: "#101829",
						type: "color"
					},
					neutral20: {
						oldValue: "#1d2330",
						value: "#1a2337",
						type: "color"
					},
					neutral25: {
						oldValue: "#222937",
						value: "#222d44",
						type: "color"
					},
					neutral30: {
						oldValue: "#2d3648",
						value: "#293650",
						type: "color"
					},
					neutral35: {
						oldValue: "#384359",
						value: "#354461",
						type: "color"
					},
					neutral40: {
						oldValue: "#44516b",
						value: "#405172",
						type: "color"
					},
					neutral45: {
						oldValue: "#4f5e7c",
						value: "#526386",
						type: "color"
					},
					neutral50: {
						oldValue: "#68758f",
						value: "#637599",
						type: "color"
					},
					neutral60: {
						oldValue: "#818ca2",
						value: "#7d8cab",
						type: "color"
					},
					neutral65: {
						oldValue: "#8e98ac",
						value: "#8a98b4",
						type: "color"
					},
					neutral70: {
						oldValue: "#9aa3b5",
						value: "#96a3bd",
						type: "color"
					},
					neutral75: {
						oldValue: "#b4bbc9",
						value: "#aab4cc",
						type: "color"
					},
					neutral80: {
						oldValue: "#c0c6d3",
						value: "#bdc6da",
						type: "color"
					},
					neutral85: {
						oldValue: "#d2d7e1",
						value: "#d0d7e8",
						type: "color"
					},
					neutral90: {
						oldValue: "#e5e8ef",
						value: "#e2e8f6",
						type: "color"
					},
					neutral95: {
						oldValue: "#f2f3f7",
						value: "#f0f3ff",
						type: "color"
					},
					neutral99: {
						value: "#f9f9fb",
						type: "color"
					},
					neutral100: {
						value: "#ffffff",
						type: "color"
					}
				},
				success: {
					success0: {
						value: "#000000",
						type: "color"
					},
					success10: {
						oldValue: "#082e00",
						value: "#092e01",
						type: "color"
					},
					success20: {
						value: "#0c4500",
						type: "color"
					},
					success30: {
						oldValue: "#0f5b00",
						value: "#105b01",
						type: "color"
					},
					success40: {
						oldValue: "#137200",
						value: "#147201",
						type: "color"
					},
					success50: {
						oldValue: "#178900",
						value: "#188901",
						type: "color"
					},
					success60: {
						oldValue: "#36a900",
						value: "#36a902",
						type: "color"
					},
					success70: {
						oldValue: "#56c900",
						value: "#56c903",
						type: "color"
					},
					success80: {
						oldValue: "#75e900",
						value: "#75e904",
						type: "color"
					},
					success90: {
						oldValue: "#a3f055",
						value: "#97f400",
						type: "color"
					},
					success95: {
						oldValue: "#d1f8aa",
						value: "#c3ff80",
						type: "color"
					},
					success99: {
						oldValue: "#f7fef1",
						value: "#f6ffed",
						type: "color"
					},
					success100: {
						value: "#ffffff",
						type: "color"
					}
				},
				caution: {
					caution0: {
						value: "#000000",
						type: "color"
					},
					caution10: {
						oldValue: "#2f2308",
						value: "#312200",
						type: "color"
					},
					caution20: {
						oldValue: "#5e4510",
						value: "#604400",
						type: "color"
					},
					caution30: {
						oldValue: "#8d6818",
						value: "#8f6700",
						type: "color"
					},
					caution40: {
						oldValue: "#bb881a",
						value: "#bd8700",
						type: "color"
					},
					caution50: {
						oldValue: "#e8a81c",
						value: "#eaa700",
						type: "color"
					},
					caution60: {
						oldValue: "#f3be21",
						value: "#f5bd03",
						type: "color"
					},
					caution70: {
						value: "#ffd426",
						type: "color"
					},
					caution80: {
						value: "#ffdd51",
						type: "color"
					},
					caution90: {
						value: "#ffe57d",
						type: "color"
					},
					caution95: {
						value: "#ffeea8",
						type: "color"
					},
					caution99: {
						value: "#fff6d4",
						type: "color"
					},
					caution100: {
						value: "#ffffff",
						type: "color"
					}
				},
				chat: {
					light: {
						chatSenderTextBubble: {
							value: "#005ef9",
							type: "color"
						},
						chatRecipientTextBubble: {
							oldValue: "#e2e8f6",
							value: "#d0d7e8",
							type: "color"
						},
						recipientBodyText: {
							oldValue: "#dee9ff",
							value: "#070d1a",
							type: "color"
						},
						senderBodyText: {
							oldValue: "#005ef9",
							value: "#f0f3ff",
							type: "color"
						},
						recipientLabelText: {
							value: "#637599",
							type: "color"
						},
						senderLabelText: {
							value: "#c4d9ff",
							type: "color"
						},
						onChatAvatar: {
							value: "#ebf2ff",
							type: "color"
						},
						chatAvatar: {
							value: "#637599",
							type: "color"
						}
					},
					dark: {
						chatSenderTextBubble: {
							value: "#0058e8",
							type: "color"
						},
						chatRecipientTextBubble: {
							value: "#293650",
							type: "color"
						},
						recipientBodyText: {
							value: "#f0f3ff",
							type: "color"
						},
						senderBodyText: {
							value: "#f0f3ff",
							type: "color"
						},
						recipientLabelText: {
							value: "#bdc6da",
							type: "color"
						},
						senderLabelText: {
							value: "#c4d9ff",
							type: "color"
						},
						onChatAvatar: {
							value: "#f0f3ff",
							type: "color"
						},
						chatAvatar: {
							value: "#637599",
							type: "color"
						}
					}
				},
				severity: {
					onUnknown: {
						value: "#3a00a7",
						type: "color"
					},
					unknown: {
						value: "#efedff",
						type: "color"
					},
					onMinor: {
						value: "#ffffff",
						type: "color"
					},
					minor: {
						value: "#526386",
						type: "color"
					},
					onModerate: {
						value: "#604400",
						type: "color"
					},
					moderate: {
						value: "#ffd426",
						type: "color"
					},
					onSevere: {
						value: "#312200",
						type: "color"
					},
					severe: {
						value: "#ff8c3b",
						type: "color"
					},
					onExtreme: {
						value: "#ffeded",
						type: "color"
					},
					extreme: {
						value: "#ea0010",
						type: "color"
					},
					onAlternative: {
						value: "#092e01",
						type: "color"
					},
					alternative: {
						value: "#56c903",
						type: "color"
					}
				}
			}
		},
		"key-colors": {
			primary: {
				value: "#6750a4",
				type: "color"
			}
		},
		source: {
			seed: {
				value: "#1d64e8",
				type: "color",
				description: "TYPE: CUSTOM"
			}
		},
		surfaces: {
			light: {
				flatSurface: {
					value: "#dfe9fc",
					type: "color"
				},
				background: {
					value: "linear-gradient(180deg, #ebf1fd 0%, #e5ecf9 100%)",
					type: "color"
				},
				surface: {
					value: "linear-gradient(180deg, #fbfbfd 0%, #fdfdff 100%)",
					type: "color"
				},
				surface1: {
					value: "linear-gradient(180deg, #f2f6fa 0%, #f9f9fb 100%, #f8fafe 100%)",
					type: "color"
				},
				surface2: {
					value: "linear-gradient(180deg, #e9edf7 0%, #eef2fc 100%)",
					type: "color"
				},
				surface3: {
					value: "linear-gradient(180deg, #dfe6f5 0%, #e6edf9 100%)",
					type: "color"
				},
				surface4: {
					value: "linear-gradient(180deg, #dbe2f1 0%, #dfe7f5 100%)",
					type: "color"
				},
				surface5: {
					value: "linear-gradient(180deg, #d4dbeb 0%, #dae2ef 100%)",
					type: "color"
				}
			},
			dark: {
				flatSurface: {
					value: "linear-gradient(180deg, #090c14 0%, #0a0d15 100%)",
					type: "color"
				},
				background: {
					value: "linear-gradient(180deg, #0c1320 0%, #090e19 100%)",
					type: "color"
				},
				surface: {
					value: "linear-gradient(180deg, #0c111b 0%, #101726 100%)",
					type: "color"
				},
				surface1: {
					value: "linear-gradient(180deg, #0c1220 0%, #111929 100%)",
					type: "color"
				},
				surface2: {
					value: "linear-gradient(180deg, #0c1424 0%, #111b2d 100%)",
					type: "color"
				},
				surface3: {
					value: "linear-gradient(180deg, #0d1628 0%, #111b31 100%)",
					type: "color"
				},
				surface4: {
					value: "linear-gradient(180deg, #0d172c 0%, #111e35 100%)",
					type: "color"
				},
				surface5: {
					value: "linear-gradient(180deg, #0e1b35 0%, #12213d 100%)",
					type: "color"
				}
			}
		},
		"state-layers": {
			light: {
				primary: {
					"opacity-0": {
						"12": {
							value: "#1956c71f",
							type: "color"
						},
						"16": {
							value: "#1956c729",
							type: "color"
						},
						"24": {
							value: "#1956c73d",
							type: "color"
						},
						"08": {
							value: "#1956c714",
							type: "color"
						}
					}
				},
				"on-primary": {
					"opacity-0": {
						"12": {
							value: "#ffffff1f",
							type: "color"
						},
						"16": {
							value: "#ffffff29",
							type: "color"
						},
						"08": {
							value: "#ffffff14",
							type: "color"
						}
					}
				},
				"primary-container": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"on-primary-container": {
					"opacity-0": {
						"12": {
							value: "#1956c71f",
							type: "color"
						},
						"16": {
							value: "#1956c729",
							type: "color"
						},
						"08": {
							value: "#1956c714",
							type: "color"
						}
					}
				},
				"primary-fixed": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"on-primary-fixed": {
					"opacity-0": {
						"12": {
							value: "#1139851f",
							type: "color"
						},
						"16": {
							value: "#11398529",
							type: "color"
						},
						"08": {
							value: "#11398514",
							type: "color"
						}
					}
				},
				"primary-fixed-dim": {
					"opacity-0": {
						"12": {
							value: "#dfe9fc1f",
							type: "color"
						},
						"16": {
							value: "#dfe9fc29",
							type: "color"
						},
						"08": {
							value: "#dfe9fc14",
							type: "color"
						}
					}
				},
				"on-primary-fixed-variant": {
					"opacity-0": {
						"12": {
							value: "#3d7aeb1f",
							type: "color"
						},
						"16": {
							value: "#3d7aeb29",
							type: "color"
						},
						"08": {
							value: "#3d7aeb14",
							type: "color"
						}
					}
				},
				secondary: {
					"opacity-0": {
						"12": {
							value: "#68758f1f",
							type: "color"
						},
						"16": {
							value: "#68758f29",
							type: "color"
						},
						"08": {
							value: "#68758f14",
							type: "color"
						}
					}
				},
				"on-secondary": {
					"opacity-0": {
						"12": {
							value: "#ffffff1f",
							type: "color"
						},
						"16": {
							value: "#ffffff29",
							type: "color"
						},
						"08": {
							value: "#ffffff14",
							type: "color"
						}
					}
				},
				"secondary-container": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"on-secondary-container": {
					"opacity-0": {
						"12": {
							value: "#1d64e81f",
							type: "color"
						},
						"16": {
							value: "#1d64e829",
							type: "color"
						},
						"08": {
							value: "#1d64e814",
							type: "color"
						}
					}
				},
				"secondary-fixed": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"on-secondary-fixed": {
					"opacity-0": {
						"12": {
							value: "#1d23301f",
							type: "color"
						},
						"16": {
							value: "#1d233029",
							type: "color"
						},
						"08": {
							value: "#1d233014",
							type: "color"
						}
					}
				},
				"secondary-fixed-dim": {
					"opacity-0": {
						"12": {
							value: "#ccd1dc1f",
							type: "color"
						},
						"16": {
							value: "#ccd1dc29",
							type: "color"
						},
						"08": {
							value: "#ccd1dc14",
							type: "color"
						}
					}
				},
				"on-secondary-fixed-variant": {
					"opacity-0": {
						"12": {
							value: "#44516b1f",
							type: "color"
						},
						"16": {
							value: "#44516b29",
							type: "color"
						},
						"08": {
							value: "#44516b14",
							type: "color"
						}
					}
				},
				tertiary: {
					"opacity-0": {
						"12": {
							value: "#7d52601f",
							type: "color"
						},
						"16": {
							value: "#7d526029",
							type: "color"
						},
						"08": {
							value: "#7d526014",
							type: "color"
						}
					}
				},
				"on-tertiary": {
					"opacity-0": {
						"12": {
							value: "#ffffff1f",
							type: "color"
						},
						"16": {
							value: "#ffffff29",
							type: "color"
						},
						"08": {
							value: "#ffffff14",
							type: "color"
						}
					}
				},
				"tertiary-container": {
					"opacity-0": {
						"12": {
							value: "#ffd8e41f",
							type: "color"
						},
						"16": {
							value: "#ffd8e429",
							type: "color"
						},
						"08": {
							value: "#ffd8e414",
							type: "color"
						}
					}
				},
				"on-tertiary-container": {
					"opacity-0": {
						"12": {
							value: "#31111d1f",
							type: "color"
						},
						"16": {
							value: "#31111d29",
							type: "color"
						},
						"08": {
							value: "#31111d14",
							type: "color"
						}
					}
				},
				"tertiary-fixed": {
					"opacity-0": {
						"12": {
							value: "#ffd8e41f",
							type: "color"
						},
						"16": {
							value: "#ffd8e429",
							type: "color"
						},
						"08": {
							value: "#ffd8e414",
							type: "color"
						}
					}
				},
				"on-tertiary-fixed": {
					"opacity-0": {
						"12": {
							value: "#31111d1f",
							type: "color"
						},
						"16": {
							value: "#31111d29",
							type: "color"
						},
						"08": {
							value: "#31111d14",
							type: "color"
						}
					}
				},
				"tertiary-fixed-dim": {
					"opacity-0": {
						"12": {
							value: "#efb8c81f",
							type: "color"
						},
						"16": {
							value: "#efb8c829",
							type: "color"
						},
						"08": {
							value: "#efb8c814",
							type: "color"
						}
					}
				},
				"on-tertiary-fixed-variant": {
					"opacity-0": {
						"12": {
							value: "#633b481f",
							type: "color"
						},
						"16": {
							value: "#633b4829",
							type: "color"
						},
						"08": {
							value: "#633b4814",
							type: "color"
						}
					}
				},
				error: {
					"opacity-0": {
						"12": {
							value: "#b3261e1f",
							type: "color"
						},
						"16": {
							value: "#b3261e29",
							type: "color"
						},
						"08": {
							value: "#b3261e14",
							type: "color"
						}
					}
				},
				"on-error": {
					"opacity-0": {
						"12": {
							value: "#ffffff1f",
							type: "color"
						},
						"16": {
							value: "#ffffff29",
							type: "color"
						},
						"08": {
							value: "#ffffff14",
							type: "color"
						}
					}
				},
				"error-container": {
					"opacity-0": {
						"12": {
							value: "#f9dedc1f",
							type: "color"
						},
						"16": {
							value: "#f9dedc29",
							type: "color"
						},
						"08": {
							value: "#f9dedc14",
							type: "color"
						}
					}
				},
				"on-error-container": {
					"opacity-0": {
						"12": {
							value: "#410e0b1f",
							type: "color"
						},
						"16": {
							value: "#410e0b29",
							type: "color"
						},
						"08": {
							value: "#410e0b14",
							type: "color"
						}
					}
				},
				outline: {
					"opacity-0": {
						"12": {
							value: "#818ca21f",
							type: "color"
						},
						"16": {
							value: "#818ca229",
							type: "color"
						},
						"08": {
							value: "#818ca214",
							type: "color"
						}
					}
				},
				background: {
					"opacity-0": {
						"12": {
							value: "#f8fafe1f",
							type: "color"
						},
						"16": {
							value: "#fef7ff29",
							type: "color"
						},
						"08": {
							value: "#f8fafe",
							type: "color"
						}
					}
				},
				"on-background": {
					"opacity-0": {
						"12": {
							value: "#1d23301f",
							type: "color"
						},
						"16": {
							value: "#1d233029",
							type: "color"
						},
						"08": {
							value: "#1d233014",
							type: "color"
						}
					}
				},
				surface: {
					"opacity-0": {
						"12": {
							value: "#f8fafe1f",
							type: "color"
						},
						"16": {
							value: "#f8fafe29",
							type: "color"
						},
						"08": {
							value: "#f8fafe14",
							type: "color"
						}
					}
				},
				"on-surface": {
					"opacity-0": {
						"12": {
							value: "#1d64e81f",
							type: "color"
						},
						"16": {
							value: "#1d64e829",
							type: "color"
						},
						"08": {
							value: "#1d64e814",
							type: "color"
						}
					}
				},
				"surface-variant": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"on-surface-variant": {
					"opacity-0": {
						"12": {
							value: "#68758f1f",
							type: "color"
						},
						"16": {
							value: "#68758f29",
							type: "color"
						},
						"08": {
							value: "#68758f14",
							type: "color"
						}
					}
				},
				"inverse-surface": {
					"opacity-0": {
						"12": {
							value: "#3843591f",
							type: "color"
						},
						"16": {
							value: "#38435929",
							type: "color"
						},
						"08": {
							value: "#38435914",
							type: "color"
						}
					}
				},
				"inverse-on-surface": {
					"opacity-0": {
						"12": {
							value: "#f8fafe1f",
							type: "color"
						},
						"16": {
							value: "#f8fafe29",
							type: "color"
						},
						"08": {
							value: "#f8fafe14",
							type: "color"
						}
					}
				},
				"inverse-primary": {
					"opacity-0": {
						"12": {
							value: "#dfe9fc1f",
							type: "color"
						},
						"16": {
							value: "#dfe9fc29",
							type: "color"
						},
						"08": {
							value: "#dfe9fc14",
							type: "color"
						}
					}
				},
				shadow: {
					"opacity-0": {
						"12": {
							value: "#0000001f",
							type: "color"
						},
						"16": {
							value: "#00000029",
							type: "color"
						},
						"08": {
							value: "#00000014",
							type: "color"
						}
					}
				},
				"surface-tint": {
					"opacity-0": {
						"12": {
							value: "#1d64e81f",
							type: "color"
						},
						"16": {
							value: "#1d64e829",
							type: "color"
						},
						"08": {
							value: "#1d64e814",
							type: "color"
						}
					}
				},
				"outline-variant": {
					"opacity-0": {
						"12": {
							value: "#ccd1dc1f",
							type: "color"
						},
						"16": {
							value: "#ccd1dc29",
							type: "color"
						},
						"08": {
							value: "#ccd1dc14",
							type: "color"
						}
					}
				},
				scrim: {
					"opacity-0": {
						"12": {
							value: "#0000001f",
							type: "color"
						},
						"16": {
							value: "#00000029",
							type: "color"
						},
						"08": {
							value: "#00000014",
							type: "color"
						}
					}
				},
				"surface-container-highest": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"surface-container-high": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"surface-container": {
					"opacity-0": {
						"12": {
							value: "#f8fafe1f",
							type: "color"
						},
						"16": {
							value: "#f8fafe29",
							type: "color"
						},
						"08": {
							value: "#f8fafe14",
							type: "color"
						}
					}
				},
				"surface-container-low": {
					"opacity-0": {
						"12": {
							value: "#f8fafe1f",
							type: "color"
						},
						"16": {
							value: "#f8fafe29",
							type: "color"
						},
						"08": {
							value: "#f8fafe14",
							type: "color"
						}
					}
				},
				"surface-container-lowest": {
					"opacity-0": {
						"12": {
							value: "#ffffff1f",
							type: "color"
						},
						"16": {
							value: "#ffffff29",
							type: "color"
						},
						"08": {
							value: "#ffffff14",
							type: "color"
						}
					}
				},
				"surface-bright": {
					"opacity-0": {
						"12": {
							value: "#f8fafe1f",
							type: "color"
						},
						"16": {
							value: "#f8fafe29",
							type: "color"
						},
						"08": {
							value: "#f8fafe14",
							type: "color"
						}
					}
				},
				"surface-dim": {
					"opacity-0": {
						"12": {
							value: "#dfe9fc1f",
							type: "color"
						},
						"16": {
							value: "#dfe9fc29",
							type: "color"
						},
						"08": {
							value: "#dfe9fc14",
							type: "color"
						}
					}
				}
			},
			dark: {
				primary: {
					"opacity-0": {
						"12": {
							value: "#1d64e81f",
							type: "color"
						},
						"16": {
							value: "#1d64e829",
							type: "color"
						},
						"08": {
							value: "#1d64e814",
							type: "color"
						}
					}
				},
				"on-primary": {
					"opacity-0": {
						"12": {
							value: "#5e90ef1f",
							type: "color"
						},
						"16": {
							value: "#5e90ef29",
							type: "color"
						},
						"08": {
							value: "#5e90ef14",
							type: "color"
						}
					}
				},
				"primary-container": {
					"opacity-0": {
						"12": {
							value: "#4f5e7c1f",
							type: "color"
						},
						"16": {
							value: "#4f5e7c29",
							type: "color"
						},
						"08": {
							value: "#4f5e7c14",
							type: "color"
						}
					}
				},
				"on-primary-container": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"primary-fixed": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"on-primary-fixed": {
					"opacity-0": {
						"12": {
							value: "#1d64e81f",
							type: "color"
						},
						"16": {
							value: "#1d64e829",
							type: "color"
						},
						"08": {
							value: "#1d64e814",
							type: "color"
						}
					}
				},
				"primary-fixed-dim": {
					"opacity-0": {
						"12": {
							value: "#dfe9fc1f",
							type: "color"
						},
						"16": {
							value: "#dfe9fc29",
							type: "color"
						},
						"08": {
							value: "#dfe9fc14",
							type: "color"
						}
					}
				},
				"on-primary-fixed-variant": {
					"opacity-0": {
						"12": {
							value: "#44516b1f",
							type: "color"
						},
						"16": {
							value: "#44516b29",
							type: "color"
						},
						"08": {
							value: "#44516b14",
							type: "color"
						}
					}
				},
				secondary: {
					"opacity-0": {
						"12": {
							value: "#ccd1dc1f",
							type: "color"
						},
						"16": {
							value: "#ccd1dc29",
							type: "color"
						},
						"08": {
							value: "#ccd1dc14",
							type: "color"
						}
					}
				},
				"on-secondary": {
					"opacity-0": {
						"12": {
							value: "#3843591f",
							type: "color"
						},
						"16": {
							value: "#38435929",
							type: "color"
						},
						"08": {
							value: "#38435914",
							type: "color"
						}
					}
				},
				"secondary-container": {
					"opacity-0": {
						"12": {
							value: "#44516b1f",
							type: "color"
						},
						"16": {
							value: "#44516b29",
							type: "color"
						},
						"08": {
							value: "#44516b14",
							type: "color"
						}
					}
				},
				"on-secondary-container": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"secondary-fixed": {
					"opacity-0": {
						"12": {
							value: "#ecf2fd1f",
							type: "color"
						},
						"16": {
							value: "#ecf2fd29",
							type: "color"
						},
						"08": {
							value: "#ecf2fd14",
							type: "color"
						}
					}
				},
				"on-secondary-fixed": {
					"opacity-0": {
						"12": {
							value: "#1d23301f",
							type: "color"
						},
						"16": {
							value: "#1d233029",
							type: "color"
						},
						"08": {
							value: "#1d233014",
							type: "color"
						}
					}
				},
				"secondary-fixed-dim": {
					"opacity-0": {
						"12": {
							value: "#ccc2dc1f",
							type: "color"
						},
						"16": {
							value: "#ccd1dc29",
							type: "color"
						},
						"08": {
							value: "#ccd1dc14",
							type: "color"
						}
					}
				},
				"on-secondary-fixed-variant": {
					"opacity-0": {
						"12": {
							value: "#44516b1f",
							type: "color"
						},
						"16": {
							value: "#44516b29",
							type: "color"
						},
						"08": {
							value: "#44516b14",
							type: "color"
						}
					}
				},
				tertiary: {
					"opacity-0": {
						"12": {
							value: "#efb8c81f",
							type: "color"
						},
						"16": {
							value: "#efb8c829",
							type: "color"
						},
						"08": {
							value: "#efb8c814",
							type: "color"
						}
					}
				},
				"on-tertiary": {
					"opacity-0": {
						"12": {
							value: "#4925321f",
							type: "color"
						},
						"16": {
							value: "#49253229",
							type: "color"
						},
						"08": {
							value: "#49253214",
							type: "color"
						}
					}
				},
				"tertiary-container": {
					"opacity-0": {
						"12": {
							value: "#633b481f",
							type: "color"
						},
						"16": {
							value: "#633b4829",
							type: "color"
						},
						"08": {
							value: "#633b4814",
							type: "color"
						}
					}
				},
				"on-tertiary-container": {
					"opacity-0": {
						"12": {
							value: "#ffd8e41f",
							type: "color"
						},
						"16": {
							value: "#ffd8e429",
							type: "color"
						},
						"08": {
							value: "#ffd8e414",
							type: "color"
						}
					}
				},
				"tertiary-fixed": {
					"opacity-0": {
						"12": {
							value: "#ffd8e41f",
							type: "color"
						},
						"16": {
							value: "#ffd8e429",
							type: "color"
						},
						"08": {
							value: "#ffd8e414",
							type: "color"
						}
					}
				},
				"on-tertiary-fixed": {
					"opacity-0": {
						"12": {
							value: "#31111d1f",
							type: "color"
						},
						"16": {
							value: "#31111d29",
							type: "color"
						},
						"08": {
							value: "#31111d14",
							type: "color"
						}
					}
				},
				"tertiary-fixed-dim": {
					"opacity-0": {
						"12": {
							value: "#efb8c81f",
							type: "color"
						},
						"16": {
							value: "#efb8c829",
							type: "color"
						},
						"08": {
							value: "#efb8c814",
							type: "color"
						}
					}
				},
				"on-tertiary-fixed-variant": {
					"opacity-0": {
						"12": {
							value: "#633b481f",
							type: "color"
						},
						"16": {
							value: "#633b4829",
							type: "color"
						},
						"08": {
							value: "#633b4814",
							type: "color"
						}
					}
				},
				error: {
					"opacity-0": {
						"12": {
							value: "#f2b8b51f",
							type: "color"
						},
						"16": {
							value: "#f2b8b529",
							type: "color"
						},
						"08": {
							value: "#f2b8b514",
							type: "color"
						}
					}
				},
				"on-error": {
					"opacity-0": {
						"12": {
							value: "#6014101f",
							type: "color"
						},
						"16": {
							value: "#60141029",
							type: "color"
						},
						"08": {
							value: "#60141014",
							type: "color"
						}
					}
				},
				"error-container": {
					"opacity-0": {
						"12": {
							value: "#8c1d181f",
							type: "color"
						},
						"16": {
							value: "#8c1d1829",
							type: "color"
						},
						"08": {
							value: "#8c1d1814",
							type: "color"
						}
					}
				},
				"on-error-container": {
					"opacity-0": {
						"12": {
							value: "#f9dedc1f",
							type: "color"
						},
						"16": {
							value: "#f9dedc29",
							type: "color"
						},
						"08": {
							value: "#f9dedc14",
							type: "color"
						}
					}
				},
				outline: {
					"opacity-0": {
						"12": {
							value: "#9aa3b51f",
							type: "color"
						},
						"16": {
							value: "#9aa3b529",
							type: "color"
						},
						"08": {
							value: "#9aa3b514",
							type: "color"
						}
					}
				},
				background: {
					"opacity-0": {
						"12": {
							value: "#161b261f",
							type: "color"
						},
						"16": {
							value: "#161b2629",
							type: "color"
						},
						"08": {
							value: "#161b2614",
							type: "color"
						}
					}
				},
				"on-background": {
					"opacity-0": {
						"12": {
							value: "#e5e8ef1f",
							type: "color"
						},
						"16": {
							value: "#e5e8ef29",
							type: "color"
						},
						"08": {
							value: "#e5e8ef14",
							type: "color"
						}
					}
				},
				surface: {
					"opacity-0": {
						"12": {
							value: "#1412181f",
							type: "color"
						},
						"16": {
							value: "#14121829",
							type: "color"
						},
						"08": {
							value: "#14121814",
							type: "color"
						}
					}
				},
				"on-surface": {
					"opacity-0": {
						"12": {
							value: "#1d64e81f",
							type: "color"
						},
						"16": {
							value: "#1d64e829",
							type: "color"
						},
						"08": {
							value: "#1d64e814",
							type: "color"
						}
					}
				},
				"surface-variant": {
					"opacity-0": {
						"12": {
							value: "#44516b1f",
							type: "color"
						},
						"16": {
							value: "#44516b29",
							type: "color"
						},
						"08": {
							value: "#44516b14",
							type: "color"
						}
					}
				},
				"on-surface-variant": {
					"opacity-0": {
						"12": {
							value: "#c0c6d31f",
							type: "color"
						},
						"16": {
							value: "#c0c6d329",
							type: "color"
						},
						"08": {
							value: "#c0c6d314",
							type: "color"
						}
					}
				},
				"inverse-surface": {
					"opacity-0": {
						"12": {
							value: "#e5e8ef1f",
							type: "color"
						},
						"16": {
							value: "#e5e8ef29",
							type: "color"
						},
						"08": {
							value: "#e5e8ef14",
							type: "color"
						}
					}
				},
				"inverse-on-surface": {
					"opacity-0": {
						"12": {
							value: "#322f351f",
							type: "color"
						},
						"16": {
							value: "#322f3529",
							type: "color"
						},
						"08": {
							value: "#322f3514",
							type: "color"
						}
					}
				},
				"inverse-primary": {
					"opacity-0": {
						"12": {
							value: "#3d7aeb1f",
							type: "color"
						},
						"16": {
							value: "#3d7aeb29",
							type: "color"
						},
						"08": {
							value: "#3d7aeb14",
							type: "color"
						}
					}
				},
				shadow: {
					"opacity-0": {
						"12": {
							value: "#0000001f",
							type: "color"
						},
						"16": {
							value: "#00000029",
							type: "color"
						},
						"08": {
							value: "#00000014",
							type: "color"
						}
					}
				},
				"surface-tint": {
					"opacity-0": {
						"12": {
							value: "#dfe9fc1f",
							type: "color"
						},
						"16": {
							value: "#dfe9fc29",
							type: "color"
						},
						"08": {
							value: "#dfe9fc14",
							type: "color"
						}
					}
				},
				"outline-variant": {
					"opacity-0": {
						"12": {
							value: "#4f5e7c1f",
							type: "color"
						},
						"16": {
							value: "#4f5e7c29",
							type: "color"
						},
						"08": {
							value: "#4f5e7c14",
							type: "color"
						}
					}
				},
				scrim: {
					"opacity-0": {
						"12": {
							value: "#0000001f",
							type: "color"
						},
						"16": {
							value: "#00000029",
							type: "color"
						},
						"08": {
							value: "#00000014",
							type: "color"
						}
					}
				},
				"surface-container-highest": {
					"opacity-0": {
						"12": {
							value: "#3843591f",
							type: "color"
						},
						"16": {
							value: "#38435929",
							type: "color"
						},
						"08": {
							value: "#38435914",
							type: "color"
						}
					}
				},
				"surface-container-high": {
					"opacity-0": {
						"12": {
							value: "#2229371f",
							type: "color"
						},
						"16": {
							value: "#22293729",
							type: "color"
						},
						"08": {
							value: "#22293714",
							type: "color"
						}
					}
				},
				"surface-container": {
					"opacity-0": {
						"12": {
							value: "#2229371f",
							type: "color"
						},
						"16": {
							value: "#22293729",
							type: "color"
						},
						"08": {
							value: "#22293714",
							type: "color"
						}
					}
				},
				"surface-container-low": {
					"opacity-0": {
						"12": {
							value: "#161b261f",
							type: "color"
						},
						"16": {
							value: "#161b2629",
							type: "color"
						},
						"08": {
							value: "#161b2614",
							type: "color"
						}
					}
				},
				"surface-container-lowest": {
					"opacity-0": {
						"12": {
							value: "#0a0d141f",
							type: "color"
						},
						"16": {
							value: "#0a0d1429",
							type: "color"
						},
						"08": {
							value: "#0a0d1414",
							type: "color"
						}
					}
				},
				"surface-bright": {
					"opacity-0": {
						"12": {
							value: "#3843591f",
							type: "color"
						},
						"16": {
							value: "#38435929",
							type: "color"
						},
						"08": {
							value: "#38435914",
							type: "color"
						}
					}
				},
				"surface-dim": {
					"opacity-0": {
						"12": {
							value: "#161b261f",
							type: "color"
						},
						"16": {
							value: "#161b2629",
							type: "color"
						},
						"08": {
							value: "#161b2614",
							type: "color"
						}
					}
				}
			}
		},
		elevation: {
			light: {
				"1": {
					value: [
						{
							color: "#1d64e840",
							type: "dropShadow",
							x: 0,
							y: 6,
							blur: 20,
							spread: -8
						},
						{
							color: "#0000000d",
							type: "dropShadow",
							x: 0,
							y: 4,
							blur: 2,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"2": {
					value: [
						{
							color: "#1d64e840",
							type: "dropShadow",
							x: 0,
							y: 6,
							blur: 40,
							spread: -8
						},
						{
							color: "#00000014",
							type: "dropShadow",
							x: 0,
							y: 4,
							blur: 4,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"3": {
					value: [
						{
							color: "#1d64e840",
							type: "dropShadow",
							x: 0,
							y: 6,
							blur: 30,
							spread: -4
						},
						{
							color: "#00000014",
							type: "dropShadow",
							x: 0,
							y: 4,
							blur: 8,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"4left": {
					value: [
						{
							color: "#1d64e84d",
							type: "dropShadow",
							x: -15,
							y: 22,
							blur: 74,
							spread: -8
						},
						{
							color: "#0000000d",
							type: "dropShadow",
							x: 0,
							y: 4,
							blur: 4,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"4right": {
					value: [
						{
							color: "#1d64e84d",
							type: "dropShadow",
							x: 15,
							y: 22,
							blur: 74,
							spread: -8
						},
						{
							color: "#0000000d",
							type: "dropShadow",
							x: 0,
							y: 4,
							blur: 4,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"4center": {
					value: [
						{
							color: "#1d64e84d",
							type: "dropShadow",
							x: 0,
							y: 0,
							blur: 74,
							spread: -8
						},
						{
							color: "#0000000d",
							type: "dropShadow",
							x: 0,
							y: 4,
							blur: 4,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				ctaHover: {
					value: {
						color: "#1c63e999",
						type: "dropShadow",
						x: 0,
						y: 0,
						blur: 24,
						spread: 4
					},
					type: "boxShadow"
				}
			},
			dark: {
				"1": {
					value: [
						{
							color: "#0a0d14b3",
							type: "dropShadow",
							x: 4,
							y: 4,
							blur: 6,
							spread: 0
						},
						{
							color: "#f8fafe0a",
							type: "dropShadow",
							x: -1,
							y: -1,
							blur: 4,
							spread: 0
						},
						{
							color: "#0a0d14bf",
							type: "dropShadow",
							x: 1,
							y: 1,
							blur: 3,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"2": {
					value: [
						{
							color: "#0a0d14cc",
							type: "dropShadow",
							x: 4,
							y: 4,
							blur: 26,
							spread: 4
						},
						{
							color: "#f8fafe05",
							type: "dropShadow",
							x: -2,
							y: -2,
							blur: 8,
							spread: 0
						},
						{
							color: "#0000008c",
							type: "dropShadow",
							x: 2,
							y: 2,
							blur: 6,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"3": {
					value: [
						{
							color: "#0a0d14e0",
							type: "dropShadow",
							x: 4,
							y: 4,
							blur: 48,
							spread: 6
						},
						{
							color: "#f8fafe08",
							type: "dropShadow",
							x: -4,
							y: -4,
							blur: 14,
							spread: 0
						},
						{
							color: "#0a0d1480",
							type: "dropShadow",
							x: 4,
							y: 4,
							blur: 10,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"4": {
					value: [
						{
							color: "#0a0d14e6",
							type: "dropShadow",
							x: 14,
							y: 14,
							blur: 56,
							spread: 10
						},
						{
							color: "#f8fafe05",
							type: "dropShadow",
							x: -10,
							y: -10,
							blur: 16,
							spread: 0
						},
						{
							color: "#0a0d14bf",
							type: "dropShadow",
							x: 4,
							y: 4,
							blur: 14,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				ctaHover: {
					value: {
						color: "#1d64e899",
						type: "dropShadow",
						x: 0,
						y: 0,
						blur: 24,
						spread: 4
					},
					type: "boxShadow"
				}
			}
		},
		display: {
			large: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.0}",
					fontSize: "{fontSize.11}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			medium: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.1}",
					fontSize: "{fontSize.10}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			small: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.2}",
					fontSize: "{fontSize.9}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			}
		},
		headline: {
			large: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.3}",
					fontSize: "{fontSize.8}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			medium: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.4}",
					fontSize: "{fontSize.7}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			small: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.5}",
					fontSize: "{fontSize.6}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			}
		},
		title: {
			large: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-1}",
					lineHeight: "{lineHeights.6}",
					fontSize: "{fontSize.5}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			medium: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-1}",
					lineHeight: "{lineHeights.7}",
					fontSize: "{fontSize.4}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			small: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-1}",
					lineHeight: "{lineHeights.8}",
					fontSize: "{fontSize.2}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			}
		},
		body: {
			large: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.9}",
					fontSize: "{fontSize.3}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			medium: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.8}",
					fontSize: "{fontSize.2}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			small: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-0}",
					lineHeight: "{lineHeights.10}",
					fontSize: "{fontSize.1}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			"medium-bold": {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-2}",
					lineHeight: "{lineHeights.8}",
					fontSize: "{fontSize.2}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography",
				description: "Buttons"
			}
		},
		label: {
			large: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-1}",
					lineHeight: "{lineHeights.8}",
					fontSize: "{fontSize.2}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			medium: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-1}",
					lineHeight: "{lineHeights.10}",
					fontSize: "{fontSize.1}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			},
			small: {
				value: {
					fontFamily: "{fontFamilies.inter}",
					fontWeight: "{fontWeights.inter-1}",
					lineHeight: "{lineHeights.10}",
					fontSize: "{fontSize.0}",
					letterSpacing: "{letterSpacing.0}",
					paragraphSpacing: "{paragraphSpacing.0}",
					paragraphIndent: "{paragraphIndent.0}",
					textCase: "{textCase.none}",
					textDecoration: "{textDecoration.none}"
				},
				type: "typography"
			}
		},
		depression: {
			light: {
				"1": {
					value: [
						{
							color: "#acc4ec36",
							type: "innerShadow",
							x: 10,
							y: 12,
							blur: 16,
							spread: 0
						},
						{
							color: "#d4e2f933",
							type: "innerShadow",
							x: 5,
							y: 12,
							blur: 16,
							spread: 0
						},
						{
							color: "#d6e2f533",
							type: "innerShadow",
							x: -5,
							y: 2.5,
							blur: 18,
							spread: 0
						},
						{
							color: "#b8d0f64d",
							type: "innerShadow",
							x: 5,
							y: 18.5,
							blur: 30,
							spread: 0
						},
						{
							color: "#ffffff73",
							type: "innerShadow",
							x: -10,
							y: 15.050000190734863,
							blur: 15.25,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"2": {
					value: [
						{
							color: "#acc4ec36",
							type: "innerShadow",
							x: 10,
							y: 12,
							blur: 16,
							spread: 0
						},
						{
							color: "#d4e2f933",
							type: "innerShadow",
							x: 5,
							y: 12,
							blur: 16,
							spread: 0
						},
						{
							color: "#d6e2f526",
							type: "innerShadow",
							x: -5,
							y: 2.5,
							blur: 18,
							spread: 0
						},
						{
							color: "#b8d0f64d",
							type: "innerShadow",
							x: 5,
							y: 18.5,
							blur: 30,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"3": {
					value: [
						{
							color: "#acc4ec36",
							type: "innerShadow",
							x: 10,
							y: 12,
							blur: 16,
							spread: 0
						},
						{
							color: "#d4e2f903",
							type: "innerShadow",
							x: 5,
							y: 12,
							blur: 16,
							spread: 0
						},
						{
							color: "#d6e2f51a",
							type: "innerShadow",
							x: -5,
							y: 2.5,
							blur: 18,
							spread: 0
						},
						{
							color: "#b8d0f64d",
							type: "innerShadow",
							x: 5,
							y: 18.5,
							blur: 30,
							spread: 0
						},
						{
							color: "#ffffff73",
							type: "innerShadow",
							x: -10,
							y: 15.050000190734863,
							blur: 15.25,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"4": {
					value: [
						{
							color: "#acc4ec36",
							type: "innerShadow",
							x: 10,
							y: 12,
							blur: 16,
							spread: 0
						},
						{
							color: "#d6e2f50d",
							type: "innerShadow",
							x: -5,
							y: 2.5,
							blur: 18,
							spread: 0
						},
						{
							color: "#b8d0f64d",
							type: "innerShadow",
							x: 5,
							y: 18.5,
							blur: 30,
							spread: 0
						}
					],
					type: "boxShadow"
				},
				"5": {
					value: [
						{
							color: "#d6e2f500",
							type: "innerShadow",
							x: -5,
							y: 2.5,
							blur: 18,
							spread: 0
						},
						{
							color: "#b8d0f64d",
							type: "innerShadow",
							x: 5,
							y: 18.5,
							blur: 30,
							spread: 0
						}
					],
					type: "boxShadow"
				}
			}
		}
	},
	fontSize: {
		"0": {
			value: "11",
			type: "fontSizes"
		},
		"1": {
			value: "12",
			type: "fontSizes"
		},
		"2": {
			value: "14",
			type: "fontSizes"
		},
		"3": {
			value: "16",
			type: "fontSizes"
		},
		"4": {
			value: "18",
			type: "fontSizes"
		},
		"5": {
			value: "20",
			type: "fontSizes"
		},
		"6": {
			value: "22",
			type: "fontSizes"
		},
		"7": {
			value: "24",
			type: "fontSizes"
		},
		"8": {
			value: "28",
			type: "fontSizes"
		},
		"9": {
			value: "32",
			type: "fontSizes"
		},
		"10": {
			value: "42",
			type: "fontSizes"
		},
		"11": {
			value: "50",
			type: "fontSizes"
		}
	},
	textCase: {
		none: {
			value: "none",
			type: "textCase"
		}
	},
	textDecoration: {
		none: {
			value: "none",
			type: "textDecoration"
		}
	},
	paragraphIndent: {
		"0": {
			value: "0px",
			type: "dimension"
		}
	}
};

var customizeColors = {
  'M3': {
    'sys': {
      'light': {},
      'dark': {}
    },
    elevation: {
      light: {
        glassLarge: {
          value: [{
            'color': 'rgba(27, 30, 38, 0.08)',
            'type': 'dropShadow',
            'x': '0',
            'y': '4',
            'blur': '4',
            'spread': '0'
          }, {
            'color': 'rgba(29, 100, 232, 0.25)',
            'type': 'dropShadow',
            'x': '0',
            'y': '6',
            'blur': '32',
            'spread': '-8'
          }]
        }
      },
      dark: {
        glassLarge: {
          value: [{
            'color': 'rgba(248, 250, 254, 0.02)',
            'type': 'dropShadow',
            'x': '-6',
            'y': '-6',
            'blur': '16',
            'spread': '0'
          }, {
            'color': '#0A0D14',
            'type': 'dropShadow',
            'x': '12',
            'y': '12',
            'blur': '56',
            'spread': '0'
          }]
        }
      }
    },
    title: {
      large: {
        value: {
          fontWeight: 600,
          fontSize: '22px',
          lineHeight: '28px'
        }
      },
      medium: {
        value: {
          fontWeight: 600,
          fontSize: '18px',
          lineHeight: '26px'
        }
      },
      small: {
        value: {
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '20px'
        }
      }
    },
    label: {
      large: {
        value: {
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '20px'
        }
      },
      medium: {
        value: {
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: '16px'
        }
      },
      small: {
        value: {
          fontWeight: 600,
          fontSize: '11px',
          lineHeight: '16px'
        }
      }
    },
    headline: {
      large: {
        value: {
          fontWeight: 400,
          fontSize: '32px',
          lineHeight: '40px'
        }
      },
      medium: {
        value: {
          fontWeight: 400,
          fontSize: '28px',
          lineHeight: '36px'
        }
      },
      small: {
        value: {
          fontWeight: 400,
          fontSize: '24px',
          lineHeight: '32px'
        }
      }
    },
    body: {
      large: {
        value: {
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '24px'
        }
      },
      medium: {
        value: {
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px'
        }
      },
      mediumBold: {
        value: {
          fontWeight: 700,
          fontSize: '14px',
          lineHeight: '20px'
        }
      },
      small: {
        value: {
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px'
        }
      }
    },
    display: {
      large: {
        value: {
          fontWeight: 400,
          fontSize: '57px',
          lineHeight: '64px'
        }
      },
      medium: {
        value: {
          fontWeight: 400,
          fontSize: '45px',
          lineHeight: '52px'
        }
      },
      small: {
        value: {
          fontWeight: 400,
          fontSize: '36px',
          lineHeight: '44px'
        }
      }
    }
  }
};

var getMixinsConfig = {
  generateStateLayer: function generateStateLayer(backgroundColor, opacity) {
    var inheritBorderRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var rules = {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: backgroundColor,
      opacity: 1,
      pointerEvents: 'none',
      borderRadius: inheritBorderRadius ? 'inherit' : 'none'
    };
    if (opacity) {
      rules.opacity = opacity;
    }
    return rules;
  },
  gradientRadiusBorder: function gradientRadiusBorder(_ref) {
    var _contentGradient$spli, _borderGradient$split;
    var radius = _ref.radius,
      borderWidth = _ref.borderWidth,
      borderGradient = _ref.borderGradient,
      contentGradient = _ref.contentGradient;
    var paddingBoxLength = ((_contentGradient$spli = contentGradient.split('gradient')) === null || _contentGradient$spli === void 0 ? void 0 : _contentGradient$spli.length) - 1;
    var borderBoxLength = ((_borderGradient$split = borderGradient.split('gradient')) === null || _borderGradient$split === void 0 ? void 0 : _borderGradient$split.length) - 1;
    var paddingBox = fill(Array(paddingBoxLength), 'padding-box');
    var borderBox = fill(Array(borderBoxLength), 'border-box');
    return {
      borderRadius: "".concat(radius, "px"),
      border: "".concat(borderWidth, "px solid transparent"),
      backgroundClip: "".concat(paddingBox.concat(borderBox)),
      backgroundOrigin: "".concat(paddingBox.concat(borderBox)),
      backgroundImage: "".concat(contentGradient, ", ").concat(borderGradient)
    };
  },
  // this adds a gradient border that is overlaid on top of the element's background
  // so that it can blend into it
  gradientRadiusBorderOverlay: function gradientRadiusBorderOverlay(_ref2) {
    var radius = _ref2.radius,
      borderWidth = _ref2.borderWidth,
      borderGradient = _ref2.borderGradient;
    return _defineProperty({
      borderRadius: "".concat(radius, "px"),
      borderWidth: '0px'
    }, '&:before', {
      content: '""',
      position: 'absolute',
      inset: '0',
      padding: "".concat(borderWidth, "px"),
      borderRadius: "".concat(radius, "px"),
      background: borderGradient,
      mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      maskComposite: 'exclude'
    });
  }
};

var transformSeverityRef = function transformSeverityRef(severityTokenValues) {
  var severityValues = {};
  for (var key in severityTokenValues) {
    severityValues[key] = severityTokenValues[key].value;
  }
  return severityValues;
};
var transformTonalRef = function transformTonalRef(tonalTokenValue) {
  var tonalValue = {};
  for (var key in tonalTokenValue) {
    var numericKey = key.replace(/[a-zA-Z]/gi, '');
    tonalValue[Number(numericKey)] = tonalTokenValue[key].value;
  }
  return tonalValue;
};
var transformRefChat = function transformRefChat(tokenRefChat) {
  var chatValues = {};
  for (var mode in tokenRefChat) {
    chatValues[mode] = {};
    for (var key in tokenRefChat[mode]) {
      chatValues[mode][key] = tokenRefChat[mode][key].value;
    }
  }
  return chatValues;
};
var transformRef = function transformRef(tokenRefValues) {
  var tonalValues = {};
  var severityValues = {};
  var chatValues = {};
  for (var key in tokenRefValues) {
    switch (key) {
      case 'primary':
      case 'secondary':
      case 'error':
      case 'neutral':
      case 'success':
      case 'caution':
        tonalValues[key] = transformTonalRef(tokenRefValues[key]);
        break;
      case 'severity':
        severityValues = transformSeverityRef(tokenRefValues[key]);
        break;
      case 'chat':
        chatValues = _objectSpread2({}, transformRefChat(tokenRefValues[key]));
        break;
    }
  }
  return _objectSpread2(_objectSpread2({}, tonalValues), {}, {
    'severity': _objectSpread2({}, severityValues),
    'chat': _objectSpread2({}, chatValues)
  });
};
var transformColor = function transformColor(tokenColor) {
  var transformedColors = {};
  for (var key in tokenColor) {
    if (key) {
      var value = tokenColor[key];
      transformedColors[key] = typeof value === 'string' ? value : value.value;
    }
  }
  transformedColors["white"] = "#FFFFFF";
  transformedColors["black"] = "#000000";
  return transformedColors;
};
var transformElevation = function transformElevation(tokenElevation) {
  var transformElevation = {};
  Object.entries(tokenElevation).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      elevation = _ref2[1];
    var shadow = _isArray(elevation.value) ? elevation.value.map(function (item) {
      return "".concat(item.x, "px ").concat(item.y, "px ").concat(item.blur, "px ").concat(item.spread, "px ").concat(item.color);
    }).join(',') : "".concat(elevation.value.x, "px ").concat(elevation.value.y, "px ").concat(elevation.value.blur, "px ").concat(elevation.value.spread, "px ").concat(elevation.value.color);
    transformElevation[key] = shadow;
  });
  return transformElevation;
};
var transformTypescaleValue = function transformTypescaleValue(typescaleValue) {
  var transformTypescaleValue = {};
  Object.entries(typescaleValue).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    var values = value.value;
    var reducedValues = {
      fontWeight: values.fontWeight,
      fontSize: values.fontSize,
      lineHeight: values.lineHeight
    };
    transformTypescaleValue[key] = reducedValues;
  });
  return transformTypescaleValue;
};
var transformStateLayer = function transformStateLayer(stateLayer) {
  var transformStateLayer = {};
  Object.entries(stateLayer).forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    var colorSeries = {};
    Object.entries(value).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        colorKey = _ref8[0],
        color = _ref8[1];
      Object.entries(color).forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          childKey = _ref10[0],
          childColor = _ref10[1];
        colorSeries["".concat(colorKey, ".").concat(childKey)] = childColor.value;
      });
    });
    transformStateLayer[_camelCase(key)] = colorSeries;
  });
  return transformStateLayer;
};
var transformTokenToTheme = function transformTokenToTheme(theme) {
  var mergeColors = _merge(token, customizeColors);
  var ref = transformRef(token.M3.sys.ref);
  var COLOR = _objectSpread2({}, transformColor(mergeColors.M3.sys[theme]));
  var elevation = transformElevation(mergeColors.M3.elevation[theme]);
  return {
    typography: {
      fontFamily: ['Inter', 'sans-serif'].join(',')
    },
    palette: {
      mode: theme,
      background: {
        "default": theme === 'light' ? '#ffffff' : '#0A0B0F'
      },
      common: {
        white: '#ffffff',
        black: '#000000'
      },
      primary: {
        main: COLOR.primary,
        contrastText: COLOR.onPrimary
      },
      secondary: {
        main: COLOR.secondary,
        contrastText: COLOR.onSecondary
      },
      error: {
        main: COLOR.error,
        contrastText: COLOR.onError
      },
      warning: {
        main: '#f7931e'
      },
      border: {
        base: theme === 'light' ? COLOR.outline : COLOR.outlineVariant
      },
      minor: {
        main: ref.severity.minor,
        contrastText: ref.severity.onMinor
      },
      moderate: {
        main: ref.severity.moderate,
        contrastText: ref.severity.onModerate
      },
      severe: {
        main: ref.severity.severe,
        contrastText: ref.severity.onSevere
      },
      extreme: {
        main: ref.severity.extreme,
        contrastText: ref.severity.onExtreme
      },
      unknown: {
        main: ref.severity.unknown,
        contrastText: ref.severity.onUnknown
      },
      mixins: getMixinsConfig,
      text: {
        // Not sure where these come from, maybe default values from MUI?
        disabled: 'rgba(0, 0, 0, 0.38)',
        primary: 'rgba(0, 0, 0, 0.87)'
      }
    },
    sys: {
      color: COLOR,
      typescale: {
        label: transformTypescaleValue(mergeColors.M3.label),
        body: transformTypescaleValue(mergeColors.M3.body),
        headline: transformTypescaleValue(mergeColors.M3.headline),
        display: transformTypescaleValue(mergeColors.M3.display),
        title: transformTypescaleValue(mergeColors.M3.title)
      },
      ref: ref,
      elevation: elevation
    },
    // remove it temporarily because it will cause warning in console of MUI
    // shadows: elevation,
    stateLayer: transformStateLayer(mergeColors.M3['state-layers'][theme]),
    surfaces: transformColor(mergeColors.M3.surfaces[theme])
  };
};
function generateStateLayerRules(backgroundColor, opacity) {
  var inheritBorderRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var rules = {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: backgroundColor,
    opacity: 1,
    pointerEvents: 'none',
    borderRadius: inheritBorderRadius ? 'inherit' : 'none'
  };
  if (opacity) {
    rules.opacity = opacity;
  }
  return rules;
}
function generateOutlineRules(borderWidth, borderColor, backgroundColor) {
  var backgroundIsGradient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var rules = {
    background: backgroundIsGradient ? "".concat(backgroundColor, " padding-box, ").concat(borderColor, " border-box") : "linear-gradient(".concat(backgroundColor, " 0 0), ").concat(borderColor),
    borderColor: 'transparent',
    backgroundClip: 'padding-box, border-box',
    borderStyle: 'solid',
    borderWidth: "".concat(borderWidth, "px")
  };
  return rules;
}
function hexColorWithOpacity(hexColor, opacity) {
  var hexOpacity = Math.floor(255 * opacity).toString(16);
  return "".concat(hexColor).concat(hexOpacity);
}
function borderRules(borderWidth, borderColor) {
  var rules = {
    '&:before': {
      content: '""',
      position: 'absolute',
      zIndex: -1,
      inset: 0,
      padding: "".concat(borderWidth, "px"),
      borderRadius: 'inherit',
      background: borderColor,
      mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);',
      maskComposite: 'exclude'
    },
    boxSizing: 'border-box',
    position: 'relative',
    zIndex: 0
  };
  return rules;
}

function getMuiAutocompletePopperTheme(mode, theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: function root() {
          return {
            // if we have a label in the input
            '& .MuiFormControl-root:has(label)': {
              '.MuiInputBase-root': {
                input: {
                  paddingTop: '12px!important',
                  paddingBottom: '0px!important'
                }
              },
              // if we have a label and multiple tags
              '.MuiAutocomplete-inputRoot:has(.MuiChip-root)': {
                paddingTop: '19px!important',
                paddingBottom: '7px!important',
                input: {
                  paddingTop: '3px!important',
                  paddingBottom: '3px!important'
                }
              }
            }
          };
        },
        popper: function popper() {
          return {
            '& .MuiPaper-root': _objectSpread2({
              color: theme.sys.color.onSurface,
              boxShadow: theme.sys.elevation[2]
            }, mode === 'dark' ? generateOutlineRules(2, theme.sys.color.outline, theme.sys.color.surfaceContainerLowest, true) : {})
          };
        }
      }
    }
  };
}

function getMuiBadgeTheme(mode, token) {
  return {
    MuiBadge: {
      styleOverrides: {
        badge: _objectSpread2({}, token.sys.typescale.label.small)
      }
    }
  };
}

function getMuiButtonTheme(mode, token) {
  return {
    MuiButton: {
      styleOverrides: {
        root: _objectSpread2(_objectSpread2({}, token.sys.typescale.body.mediumBold), {}, {
          textTransform: 'none',
          borderRadius: '100px'
        }),
        sizeMedium: {
          padding: '12px 24px'
        }
      },
      variants: [{
        props: {
          variant: 'filled'
        },
        style: function style(_ref) {
          _ref.theme;
          return {
            color: mode === 'light' ? token.sys.color.onPrimary : token.sys.color.onSurface,
            background: token.sys.color.primaryButtonCta,
            border: "1px solid ".concat(mode === 'light' ? 'transparent' : token.sys.color.outlineVariant),
            '&:hover': {
              boxShadow: token.sys.elevation.ctaHover
            },
            '&:disabled': {
              background: token.stateLayer.onSurface['opacity-0.12']
            }
          };
        }
      }, {
        props: {
          variant: 'outlined'
        },
        style: function style(_ref2) {
          _ref2.theme;
          return {
            color: mode == 'light' ? token.sys.color.primary : token.sys.color.onSurface,
            background: token.sys.color.outlinedButton,
            borderColor: token.sys.color.outline,
            '&:hover': {
              borderColor: token.sys.color.outline
            },
            '&:disabled': {
              background: 'none',
              borderColor: token.stateLayer.primary['opacity-0.12']
            }
          };
        }
      }, {
        props: {
          variant: 'text'
        },
        style: function style() {
          return {
            color: token.sys.color.primary,
            padding: '12px',
            '&:hover': {
              background: token.stateLayer.primary['opacity-0.08']
            },
            '&:focus': {
              background: token.stateLayer.primary['opacity-0.12']
            }
          };
        }
      }, {
        props: {
          variant: 'elevated'
        },
        style: function style() {
          return {
            color: mode == 'light' ? token.sys.color.primary : token.sys.color.onSurface,
            background: token.sys.color.surfaceContainerLow,
            border: "1px solid ".concat(token.sys.color.outline),
            boxShadow: token.sys.elevation[1],
            '&:hover': {
              boxShadow: token.sys.elevation[2],
              background: token.stateLayer.primary['opacity-0.08']
            },
            '&:focus': {
              boxShadow: token.sys.elevation[2],
              background: token.stateLayer.primary['opacity-0.12']
            },
            '&:disabled': {
              background: token.stateLayer.primary['opacity-0.12'],
              boxShadow: 'none'
            }
          };
        }
      }, {
        props: {
          variant: 'tonal'
        },
        style: function style(_ref3) {
          var theme = _ref3.theme;
          return {
            color: token.sys.color.onSecondaryContainer,
            background: mode === 'light' ? token.sys.ref.secondary[95] : token.sys.ref.secondary[20],
            '&:hover': {
              '&:before': mode === 'light' ? theme.palette.mixins.generateStateLayer(token.stateLayer.onSecondaryContainer['opacity-0.08']) : theme.palette.mixins.generateStateLayer(token.stateLayer.onPrimary['opacity-0.08']),
              background: token.sys.color.secondaryContainer,
              boxShadow: token.sys.elevation[1]
            },
            '&:focus': {
              '&:before': theme.palette.mixins.generateStateLayer(token.stateLayer.onPrimary['opacity-0.12']),
              background: token.sys.color.secondaryContainer
            },
            '&:disabled': {
              background: token.stateLayer.onSurface['opacity-0.12'],
              color: token.sys.color.onSurface + '61' // Maybe we want to have this stored as a real color?
            }
          };
        }
      }]
    }
  };
}

function getMuiCardTheme(mode, token) {
  return {
    MuiCard: {
      styleOverrides: {
        root: function root(_ref) {
          var theme = _ref.theme;
          return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
            color: token.sys.color.onSurface,
            borderColor: theme.sys.color.outlineVariant,
            background: theme.sys.color.surfaceContainerLowest,
            borderRadius: '16px',
            borderWidth: '1px',
            borderStyle: 'solid',
            position: 'relative',
            '&::before': {
              position: 'absolute',
              content: '""',
              opacity: 0,
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              background: token.sys.color.cardHover,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0ms'
            }
          }, "&:hover:not(.active), &:focus:not(.active), &:hover:not(.noHover)", {
            cursor: 'pointer',
            boxShadow: token.sys.elevation[1],
            '&::before': {
              opacity: 0.1
            }
          }), ' &:focus:not(.active)', {
            '&::before': {
              background: token.sys.color.selectedState,
              opacity: '0.2'
            }
          }), '&.active', {
            borderColor: token.sys.color.primary,
            boxShadow: token.sys.elevation.ctaHover,
            '&::before': {
              opacity: 0.5
            }
          }), '&.noHover', {
            '&:before': {
              display: 'block',
              background: 'transparent'
            }
          }), '&.error', {
            background: 'none',
            boxShadow: 'none',
            border: "1px solid ".concat(token.sys.color.error),
            '&:before': {
              display: 'block'
            }
          }), '&:dragged', {
            boxShadow: token.sys.elevation[3],
            '&:before': {
              display: 'block',
              background: token.sys.color.onSurface
            }
          });
        }
      },
      variants: [{
        props: {
          variant: 'filled'
        },
        style: function style(_ref3) {
          var theme = _ref3.theme;
          return {
            borderColor: theme.sys.color.outlineVariant,
            background: theme.sys.color.surfaceContainerLow,
            borderRadius: '16px',
            borderWidth: '1px',
            borderStyle: 'solid'
          };
        }
      }, {
        props: {
          variant: 'elevation'
        },
        style: function style(_ref4) {
          var theme = _ref4.theme;
          return {
            borderColor: theme.sys.color.outlineVariant,
            background: theme.sys.color.surfaceContainerLowest,
            borderRadius: '16px',
            borderWidth: '1px',
            borderStyle: 'solid'
          };
        }
      }]
    },
    MuiCardHeader: {
      styleOverrides: {
        title: _objectSpread2({}, token.sys.typescale.title.medium),
        subheader: _objectSpread2({}, token.sys.typescale.body.medium)
      }
    }
  };
}

function getMuiCheckboxTheme(mode, token) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          input: {
            width: '100%',
            height: '100%'
          }
        }
      }
    }
  };
}

function getMuiChipTheme(mode, token) {
  return {
    MuiChip: {
      styleOverrides: {
        root: function root() {
          return _objectSpread2(_objectSpread2({
            borderRadius: '0.5rem'
          }, token.sys.typescale.label.large), {}, _defineProperty(_defineProperty(_defineProperty({
            borderWidth: '1px',
            border: "1px solid ".concat(mode === 'light' ? token.sys.color.outline : token.sys.color.outlineVariant),
            backgroundColor: 'inherit',
            '&.rounded': {
              borderRadius: '30px'
            },
            '&.elevated': _objectSpread2(_objectSpread2({
              boxShadow: token.sys.elevation[1]
            }, mode === 'light' ? {} : {
              background: token.sys.color.surfaceContainerLow,
              borderColor: 'transparent'
            }), {}, {
              '&:hover': {
                boxShadow: token.sys.elevation[2]
              },
              '&:focus': {
                boxShadow: token.sys.elevation[2]
              },
              '&.Mui-disabled': {
                borderColor: 'transparent',
                background: token.stateLayer.onSurfaceVariant['opacity-0.12'],
                boxShadow: 'none'
              }
            }),
            '&.Mui-disabled': _defineProperty(_defineProperty({}, ".".concat(chipClasses.icon), {
              color: token.sys.color.onSurface
            }), ".".concat(chipClasses.label), {
              color: token.sys.color.onSurface
            }),
            '&:hover': _defineProperty({
              position: 'relative',
              borderWidth: '1px',
              '&:after': generateStateLayerRules(token.stateLayer.onSurfaceVariant['opacity-0.08'])
            }, ".".concat(chipClasses.deleteIcon), {
              color: token.sys.color.onSurface
            }),
            '&:focus': {
              position: 'relative',
              background: token.sys.color.surface,
              borderColor: token.sys.color.onSurfaceVariant,
              '&:after': generateStateLayerRules(token.stateLayer.onSurfaceVariant['opacity-0.12'])
            },
            '&::drop': {
              position: 'relative',
              backgroundColor: token.sys.color.surface,
              '&:after': generateStateLayerRules(token.stateLayer.onSurface['opacity-0.16'])
            },
            '&:active': {
              position: 'relative',
              '&:after': generateStateLayerRules(token.stateLayer.onSurfaceVariant['opacity-0.12'])
            },
            '&.selected': {
              color: token.sys.color.onSecondaryContainer,
              borderColor: mode === 'light' ? token.sys.color.outline : 'transparent',
              background: mode === 'light' ? token.sys.ref.primary[85] : token.sys.color.secondaryContainer,
              '&:hover': {
                boxShadow: token.sys.elevation[1],
                background: mode === 'light' ? "color-mix(in srgb, ".concat(token.sys.ref.primary[85], ", ").concat(token.sys.color.onSecondaryContainer, " 8%)") : "color-mix(in srgb, ".concat(token.sys.color.secondaryContainer, ", ").concat(token.sys.color.onSecondaryContainer, " 8%)")
              },
              '&:focus': {
                background: mode === 'light' ? "color-mix(in srgb, ".concat(token.sys.ref.primary[85], ", ").concat(token.sys.color.onSecondaryContainer, " 12%)") : "color-mix(in srgb, ".concat(token.sys.color.secondaryContainer, ", ").concat(token.sys.color.onSecondaryContainer, " 12%)")
              },
              '&:drop': {
                borderColor: 'transparent',
                boxShadow: token.sys.elevation[3],
                background: mode === 'light' ? "color-mix(in srgb, ".concat(token.sys.ref.primary[85], ", ").concat(token.sys.color.onSecondaryContainer, " 16%)") : "color-mix(in srgb, ".concat(token.sys.color.secondaryContainer, ", ").concat(token.sys.color.onSecondaryContainer, " 16%)")
              }
            }
          }, ".".concat(chipClasses.icon), {
            color: token.sys.color.primary
          }), ".".concat(chipClasses.label), {
            color: token.sys.color.onSurfaceVariant
          }), ".".concat(chipClasses.deleteIcon), {
            color: token.sys.color.onSurfaceVariant
          }));
        },
        sizeMedium: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
          padding: '6px 8px',
          '&.rounded': _defineProperty({
            paddingLeft: '4px',
            paddingRight: '4px'
          }, ".".concat(chipClasses.deleteIcon), {
            marginRight: '4px'
          })
        }, ".".concat(chipClasses.label), {
          padding: '0px 8px'
        }), ".".concat(chipClasses.icon), {
          fontSize: '18px',
          margin: 0
        }), ".".concat(chipClasses.avatar), {
          margin: 0
        }), ".".concat(chipClasses.deleteIcon), {
          fontSize: '18px',
          margin: 0
        }),
        colorSecondary: _defineProperty(_defineProperty({
          background: mode === 'light' ? token.sys.ref.primary[85] : token.sys.color.secondaryContainer,
          borderColor: mode === 'light' ? token.sys.color.outline : 'transparent',
          '&:hover': {
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.08'])
          },
          '&:focus': {
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.12'])
          },
          '&::drop': {
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.16'])
          },
          '&.elevated': {
            background: mode === 'light' ? token.sys.ref.primary[85] : token.sys.color.secondaryContainer
          },
          '&.Mui-disabled': {
            borderColor: 'transparent',
            background: token.stateLayer.onSurface['opacity-0.12']
          }
        }, ".".concat(chipClasses.label), {
          color: token.sys.color.onSecondaryContainer
        }), ".".concat(chipClasses.avatar), {
          color: token.sys.color.onSecondary,
          background: token.sys.color.onSecondaryContainer
        }),
        colorMinor: _defineProperty(_defineProperty({
          background: mode === 'light' ? token.sys.ref.neutral[90] : token.sys.ref.neutral[20],
          borderColor: token.sys.ref.severity.minor
        }, ".".concat(chipClasses.label), {
          color: mode === 'light' ? token.sys.ref.severity.minor : token.sys.ref.severity.onMinor
        }), '&.Mui-disabled', {
          borderColor: 'transparent',
          background: mode === 'light' ? token.stateLayer.onSurfaceVariant['opacity-0.12'] : token.stateLayer.onSurface['opacity-0.12']
        }),
        colorModerate: _defineProperty(_defineProperty({
          background: mode === 'light' ? token.sys.ref.caution[95] : token.sys.ref.caution[10],
          borderColor: token.sys.ref.severity.moderate
        }, ".".concat(chipClasses.label), {
          color: mode === 'light' ? token.sys.ref.severity.onModerate : token.sys.ref.severity.moderate
        }), '&.Mui-disabled', {
          borderColor: 'transparent',
          background: mode === 'light' ? token.stateLayer.onSurfaceVariant['opacity-0.12'] : token.stateLayer.onSurface['opacity-0.12']
        }),
        colorSevere: _defineProperty(_defineProperty({
          background: mode === 'light' ? token.sys.ref.error[90] : token.sys.ref.error[10],
          borderColor: token.sys.ref.severity.severe
        }, ".".concat(chipClasses.label), {
          color: mode === 'light' ? token.sys.ref.severity.onSevere : token.sys.ref.severity.severe
        }), '&.Mui-disabled', {
          borderColor: 'transparent',
          background: mode === 'light' ? token.stateLayer.onSurfaceVariant['opacity-0.12'] : token.stateLayer.onSurface['opacity-0.12']
        }),
        colorExtreme: _defineProperty(_defineProperty({
          background: token.sys.ref.severity.extreme,
          borderColor: 'transparent'
        }, ".".concat(chipClasses.label), {
          color: token.sys.ref.severity.onExtreme
        }), '&.Mui-disabled', {
          background: mode === 'light' ? token.stateLayer.onSurfaceVariant['opacity-0.12'] : token.stateLayer.onSurface['opacity-0.12']
        }),
        colorUnknown: _defineProperty(_defineProperty({
          background: mode === 'light' ? token.sys.ref.severity.unknown : token.sys.ref.secondary[15],
          borderColor: mode === 'light' ? token.sys.ref.secondary[80] : token.sys.ref.secondary[35]
        }, ".".concat(chipClasses.label), {
          color: mode === 'light' ? token.sys.ref.secondary[30] : token.sys.ref.severity.unknown
        }), '&.Mui-disabled', {
          borderColor: 'transparent',
          background: mode === 'light' ? token.stateLayer.onSurfaceVariant['opacity-0.12'] : token.stateLayer.onSurface['opacity-0.12']
        })
      },
      variants: [{
        props: {
          variant: 'assist'
        },
        style: {
          color: token.sys.color.onSurface
        }
      }, {
        props: {
          variant: 'nonEmergency'
        },
        style: _defineProperty({
          //background: token.sys.ref.severity.minor,
          color: token.sys.color.white,
          '&:hover': {
            boxShadow: token.sys.elevation[1],
            background: token.sys.ref.severity.minor,
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.08'])
          },
          '&:focus': {
            border: 'none',
            background: token.sys.ref.severity.minor,
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.12'])
          },
          '&:drop': {
            boxShadow: token.sys.elevation[3],
            background: token.sys.ref.severity.minor,
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.16'])
          }
        }, ".".concat(chipClasses.avatar), {
          color: token.sys.color.primary
        })
      }]
    }
  };
}

function getMuiDialogTheme(mode, token) {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {},
        paper: {
          border: "1px solid ".concat(token.sys.color.outline),
          borderRadius: '28px',
          background: token.sys.color.surfaceContainerLow,
          boxShadow: token.sys.elevation.glassLarge
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: function root() {
          return _objectSpread2({
            color: token.sys.color.onSurface
          }, token.sys.typescale.headline.small);
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: function root() {
          return _objectSpread2(_objectSpread2({
            color: token.sys.color.onSurfaceVariant
          }, token.sys.typescale.body.medium), {}, {
            paddintTop: '0 24px 24px'
          });
        }
      }
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: function root() {
          return _objectSpread2({
            color: token.sys.color.onSurfaceVariant
          }, token.sys.typescale.body.medium);
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '24px'
        }
      }
    }
  };
}

function getMuiDividerTheme(mode, token) {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderImage: "".concat(token.sys.color.outlineVariant, " 1 1")
        }
      }
    }
  };
}

function getMuiDrawerTheme(mode, token) {
  return {
    MuiDrawer: {
      styleOverrides: {
        paper: function paper() {
          return {
            '& .MuiListItemButton-root': {
              '&:hover': {
                borderRadius: '100px',
                background: token.sys.color.secondaryContainer
              }
            }
          };
        }
      }
    }
  };
}

function getMuiFabTheme(mode, token) {
  return {
    MuiFab: {
      styleOverrides: {
        sizeSmall: _objectSpread2(_objectSpread2({}, token.sys.typescale.label.small), {}, {
          height: '40px'
        }),
        sizeMedium: _objectSpread2(_objectSpread2({}, token.sys.typescale.label.medium), {}, {
          height: '48px'
        }),
        sizeLarge: _objectSpread2(_objectSpread2({}, token.sys.typescale.label.large), {}, {
          height: '56px'
        }),
        surface: {
          background: token.sys.color.surfaceContainerHighest,
          color: token.sys.color.primary,
          '&:hover': {
            '&:after': generateStateLayerRules(token.stateLayer.primary['opacity-0.08'])
          },
          '&:focus': {
            '&:after': generateStateLayerRules(token.stateLayer.primary['opacity-0.12'])
          },
          '&:active': {
            '&:after': generateStateLayerRules(token.stateLayer.primary['opacity-0.16'])
          }
        },
        primary: {
          background: token.sys.color.primaryButtonCta,
          color: mode === 'light' ? token.sys.color.onPrimary : token.palette.common.white,
          '&:hover': {
            '&:after': generateStateLayerRules(token.stateLayer.onPrimaryContainer['opacity-0.08'])
          },
          '&:focus': {
            '&:after': generateStateLayerRules(token.stateLayer.onPrimaryContainer['opacity-0.12'])
          },
          '&:active': {
            '&:after': generateStateLayerRules(token.stateLayer.onPrimaryContainer['opacity-0.16'])
          }
        },
        secondary: {
          backgroundColor: token.sys.color.secondaryContainer,
          color: token.sys.color.onSecondaryContainer,
          '&:hover': {
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.08'])
          },
          '&:focus': {
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.12'])
          },
          '&:active': {
            '&:after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.16'])
          }
        },
        tertiary: {
          // TODO: Tokenize these values
          backgroundColor: mode === 'light' ? '#FFD8E4' : '#633B48',
          color: mode === 'light' ? '#31111D' : '#FFD8E4',
          '&:hover': {
            '&:after': generateStateLayerRules(token.stateLayer.onPrimaryContainer['opacity-0.08'])
          },
          '&:focus': {
            '&:after': generateStateLayerRules(token.stateLayer.onPrimaryContainer['opacity-0.12'])
          },
          '&:active': {
            '&:after': generateStateLayerRules(token.stateLayer.onPrimaryContainer['opacity-0.16'])
          }
        }
      },
      variants: [{
        props: {
          variant: 'extended'
        },
        style: {
          borderRadius: 36
        }
      }]
    }
  };
}

function getMuiIconButtonTheme(mode, token) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: function root(_ref) {
          var theme = _ref.theme;
          return {
            color: token.sys.color.onSurface,
            '&:hover': {
              background: token.sys.color.outlinedButton
            },
            '&:disabled': {
              svg: {
                opacity: '0.38'
              }
            },
            '&:focus': {
              background: token.sys.color.outlinedButton,
              '&:before': theme.palette.mixins.generateStateLayer(token.stateLayer.onSurfaceVariant['opacity-0.12'])
            }
          };
        }
      },
      variants: [{
        props: {
          color: 'linked'
        },
        style: function style(_ref2) {
          _ref2.theme;
          return {
            color: token.sys.color.primary,
            '&:disabled': {
              color: token.sys.color.primary
            }
          };
        }
      }, {
        props: {
          color: 'filled'
        },
        style: function style(_ref3) {
          var theme = _ref3.theme;
          return {
            color: token.sys.color.onPrimary,
            background: token.sys.color.primaryButtonCta,
            '&:hover': {
              background: token.sys.color.primaryButtonCta,
              '&:before': theme.palette.mixins.generateStateLayer(token.stateLayer.onPrimary['opacity-0.08'])
            },
            '&:focus': {
              background: token.sys.color.primaryButtonCta,
              '&:before': theme.palette.mixins.generateStateLayer(token.stateLayer.onPrimary['opacity-0.12'])
            },
            '&:disabled': {
              color: token.sys.color.onSurface,
              background: token.stateLayer.onSurface['opacity-0.12']
            }
          };
        }
      }, {
        props: {
          color: 'tonal'
        },
        style: function style(_ref4) {
          var theme = _ref4.theme;
          return {
            color: token.sys.color.onSecondaryContainer,
            background: mode === 'light' ? token.sys.ref.secondary[95] : token.sys.ref.secondary[20],
            '&:hover': {
              background: mode === 'light' ? token.sys.ref.secondary[95] : token.sys.ref.secondary[20],
              '&:before': theme.palette.mixins.generateStateLayer(token.stateLayer.onSecondaryContainer['opacity-0.08'])
            },
            '&:focus': {
              background: mode === 'light' ? token.sys.ref.secondary[95] : token.sys.ref.secondary[20],
              '&:before': theme.palette.mixins.generateStateLayer(token.stateLayer.onSecondaryContainer['opacity-0.12'])
            },
            '&:disabled': {
              color: token.sys.color.onSurface,
              background: token.stateLayer.onSurface['opacity-0.12']
            }
          };
        }
      }, {
        props: {
          color: 'outlined'
        },
        style: function style(_ref5) {
          var theme = _ref5.theme;
          return {
            color: token.sys.color.primary,
            background: 'transparant',
            border: "1px solid ".concat(token.sys.color.outline),
            padding: '7px',
            '&:hover': {
              background: 'transparant',
              '&:after': theme.palette.mixins.generateStateLayer(mode === 'light' ? token.stateLayer.onSurface['opacity-0.08'] : token.stateLayer.onSurfaceVariant['opacity-0.08'])
            },
            '&:focus': {
              background: 'transparant',
              '&:after': theme.palette.mixins.generateStateLayer(mode === 'light' ? token.stateLayer.onSurface['opacity-0.12'] : token.stateLayer.onSurfaceVariant['opacity-0.12'])
            },
            '&:disabled': {
              color: token.sys.color.primary,
              borderColor: token.stateLayer.onSurface['opacity-0.12']
            }
          };
        }
      }]
    }
  };
}

function getMuiInputTheme(mode, token) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: _objectSpread2({}, token.sys.typescale.body.large),
        input: {
          '&:-webkit-autofill,&:-webkit-autofill:focus,&:-webkit-autofill:hover,&:-webkit-autofill:active': {
            WebkitBackgroundClip: 'text!important',
            boxShadow: 'none!important',
            transition: 'background-color 600000s 0s, color 600000s 0s'
          }
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: token.sys.color.onSurfaceVariant
        },
        filled: _defineProperty({}, "&.".concat(inputAdornmentClasses.positionStart), {
          marginTop: '0 !important'
        })
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          ':has(label)': {
            'input,.MuiSelect-select': {
              paddingTop: 24,
              paddingBottom: 8
            },
            textarea: {
              marginTop: '8px'
            }
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: mode === 'light' ? token.sys.color.surfaceBright : token.surfaces.flatSurface,
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: mode === 'light' ? token.sys.color.outline : token.sys.color.outlineVariant,
          // new outline / outlineVariant
          borderRadius: 4,
          'input,.MuiSelect-select': _objectSpread2(_objectSpread2({
            color: token.sys.color.onSurface
          }, token.sys.typescale.body.large), {}, {
            paddingTop: 16,
            paddingBottom: 16,
            '&::placeholder': {
              color: token.sys.color.onSurfaceVariant,
              opacity: 1
            }
          }),
          textarea: {
            color: token.sys.color.onSurface,
            marginTop: '0px'
          },
          '&:hover:not(.Mui-focused,.Mui-disabled,.Mui-error)': {
            background: mode === 'light' ? token.stateLayer.onSurface['opacity-0.08'] : token.sys.color.surfaceBright
          },
          '&.Mui-focused': {
            caretColor: token.sys.color.primary
          },
          '&.Mui-error': {
            borderColor: token.sys.color.error,
            caretColor: token.sys.color.error
          },
          '&.Mui-disabled': {
            color: token.sys.color.onSurface,
            background: mode === 'light' ? token.sys.ref.neutral[95] : token.sys.ref.neutral[20],
            opacity: 0.38,
            'input,.MuiSelect-select': {
              textFillColor: token.sys.color.onSurface
            },
            'textarea': {
              textFillColor: token.sys.color.onSurface
            },
            '.MuiChip-root': {
              opacity: 1
            }
          }
        },
        notchedOutline: {
          display: 'none'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
          color: mode === 'light' ? token.sys.ref.neutral[45] : token.sys.color.onSurfaceVariant,
          // Material-ui known issue https://github.com/mui/material-ui/issues/13898
          // If the TextField with Lable has Start Icon, the lable will be shrink to the top by default
          '&.withStartAdornment': {
            transform: 'translate(46px, 16px)'
          }
        }, "&.".concat(inputLabelClasses.shrink), _objectSpread2(_objectSpread2({}, token.sys.typescale.body.small), {}, {
          transform: 'translate(14px, 8px)',
          '&.withStartAdornment': {
            transform: 'translate(46px, 8px)'
          }
        })), '&.Mui-focused:not(.Mui-error)', {
          color: token.sys.color.primary
        }), '&.Mui-error', {
          color: token.sys.color.error
        }), '&.Mui-disabled', {
          color: token.sys.color.onSurface,
          opacity: 0.38
        })
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: _objectSpread2(_objectSpread2({
          color: token.sys.color.onSurfaceVariant,
          display: 'inline-flex',
          alignItems: 'center',
          marginTop: 4
        }, token.sys.typescale.body.small), {}, {
          svg: {
            marginRight: 4,
            fontSize: 16
          },
          '&.Mui-error': {
            marginLeft: 0
          },
          '&.Mui-disabled': {
            color: token.sys.color.onSurface,
            opacity: 0.38
          }
        })
      }
    }
  };
}

function getMuiListTheme(mode, token) {
  return {
    MuiList: {
      styleOverrides: {
        root: function root() {
          return {
            color: token.sys.color.onSurface
          };
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: function root() {
          return {
            '.MuiAvatar-root': _objectSpread2({}, token.sys.typescale.title.medium)
          };
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: function root() {
          return {
            '&:hover': {
              background: token.stateLayer.onSurface['opacity-0.08']
            },
            '&.Mui-selected': {
              background: token.stateLayer.onSurface['opacity-0.12']
            }
          };
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: function primary() {
          return _objectSpread2({}, token.sys.typescale.body.medium);
        }
      }
    }
  };
}

function getMuiMenuTheme(mode, token) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: function root() {
          return _objectSpread2(_objectSpread2({
            color: token.sys.color.onSurface
          }, token.sys.typescale.body.medium), {}, {
            paddingTop: 8,
            paddingBottom: 8,
            '&:hover': {
              background: token.stateLayer.onSurface['opacity-0.08']
            },
            '&.Mui-selected': {
              background: token.stateLayer.onSurface['opacity-0.12']
            }
          });
        }
      }
    }
  };
}

function getMuiNavigationTheme(mode, token) {
  return {
    MuiBottomNavigation: {
      styleOverrides: {
        root: function root() {
          return {
            background: token.sys.color.surfaceContainer
          };
        }
      }
    }
  };
}

function getMuiPickersPopperTheme(mode, token) {
  return {
    MuiPickersPopper: {
      styleOverrides: {
        paper: function paper(_ref) {
          var theme = _ref.theme;
          return {
            boxShadow: token.sys.elevation[2],
            background: theme.sys.color.surfaceContainerLow,
            borderRadius: '28px',
            borderWidth: '0'
          };
        }
      }
    }
  };
}

function getMuiPickersTheme(mode, token) {
  return {
    MuiPickersLayout: {
      styleOverrides: {
        root: function root(_ref) {
          var theme = _ref.theme;
          return {
            borderRadius: 28,
            background: theme.sys.color.surfaceContainerLow,
            border: "1px solid ".concat(token.sys.color.outline),
            paddingTop: 8,
            // Static Time Picker
            '.MuiTypography-overline': {
              color: theme.sys.color.onSurfaceVariant,
              textTransform: 'capitalize',
              fontSize: 12,
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: '16px',
              letterSpacing: '0.5px',
              marginBottom: 20
            },
            '&.MuiPickersLayout-landscape': {
              '.MuiTypography-overline': {
                marginBottom: 0
              },
              '.MuiPickersLayout-toolbar': {
                minWidth: '211.72px',
                padding: 0,
                margin: '16px 0 0 24px'
              },
              '.MuiTimePickerToolbar-hourMinuteLabel': {
                margin: 'auto 0'
              },
              '.MuiTimePickerToolbar-ampmSelection': {
                margin: '0',
                'button': {
                  flexGrow: 1,
                  '&:nth-of-type(odd)': {
                    borderRadius: '8px 0 0 8px',
                    '.MuiTimePickerToolbar-ampmLabel': {
                      borderRadius: '8px 0 0 8px'
                    }
                  },
                  '&:nth-of-type(even)': {
                    borderRadius: '0 8px 8px 0',
                    '.MuiTimePickerToolbar-ampmLabel': {
                      borderRadius: '0 8px 8px 0'
                    }
                  }
                }
              }
            },
            '.MuiPickersLayout-actionBar': {
              padding: '8px 12px 12px 12px'
            }
          };
        }
      }
    },
    MuiPickersToolbar: {
      styleOverrides: {
        content: function content(_ref2) {
          _ref2.theme;
          return {
            justifyContent: 'space-around'
          };
        }
      }
    },
    MuiTimePickerToolbar: {
      styleOverrides: {
        hourMinuteLabel: function hourMinuteLabel(_ref3) {
          var theme = _ref3.theme;
          return {
            'button': {
              borderRadius: 8,
              border: "1px solid ".concat(token.sys.color.outline),
              width: '96px',
              height: '80px',
              background: mode === 'light' ? theme.sys.color.surface1 : theme.sys.color.primaryFixedDim,
              '.MuiPickersToolbarText-root': {
                color: theme.sys.color.onSurface,
                lineHeight: '64px',
                fontSize: '57px'
              },
              '&:nth-of-type(even):not(:focus)': {
                background: theme.sys.color.surfaceContainerHigh
              }
            }
          };
        },
        separator: function separator(_ref4) {
          var theme = _ref4.theme;
          return {
            color: theme.sys.color.onSurface,
            lineHeight: '64px',
            fontSize: '57px',
            height: '80px',
            margin: '0 2px'
          };
        },
        ampmSelection: function ampmSelection(_ref5) {
          var theme = _ref5.theme;
          return {
            borderRadius: 8,
            border: "1px solid ".concat(token.sys.color.outline),
            background: mode === 'light' ? theme.sys.color.surfaceContainerHigh : theme.sys.color.flatSurface,
            marginRight: 'inherit',
            'button': {
              '&:nth-of-type(odd)': {
                borderRadius: '8px 8px 0 0',
                '.MuiTimePickerToolbar-ampmLabel': {
                  borderRadius: '8px 8px 0 0'
                }
              },
              '&:nth-of-type(even)': {
                borderRadius: '0 0 8px 8px',
                '.MuiTimePickerToolbar-ampmLabel': {
                  borderRadius: '0 0 8px 8px'
                }
              }
            },
            '.MuiTimePickerToolbar-ampmLabel': {
              color: theme.sys.color.onSurfaceVariant,
              padding: '8px 10px',
              fontSize: '16px',
              lineHeight: '24px',
              letterSpacing: '0.15px',
              width: '100%',
              '&.Mui-selected': {
                color: theme.sys.color.onPrimaryFixedVariant,
                background: theme.sys.color.inversePrimary
              }
            }
          };
        }
      }
    },
    MuiClock: {
      styleOverrides: {
        clock: function clock(_ref6) {
          var theme = _ref6.theme;
          return {
            border: "1px solid ".concat(token.sys.color.outline),
            background: mode === 'light' ? theme.sys.color.surfaceContainerHighest : theme.sys.color.flatSurface
          };
        }
      }
    },
    MuiClockNumber: {
      styleOverrides: {
        root: function root(_ref7) {
          var theme = _ref7.theme;
          return {
            color: theme.sys.color.onSurface,
            '&.Mui-selected': {
              color: theme.sys.color.onPrimary
            }
          };
        }
      }
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: function button(_ref8) {
          var theme = _ref8.theme;
          return {
            color: theme.sys.color.onSurfaceVariant
          };
        }
      }
    },
    MuiDatePickerToolbar: {
      styleOverrides: {
        title: function title(_ref9) {
          var theme = _ref9.theme;
          return _objectSpread2({
            color: theme.sys.color.onSurface
          }, theme.sys.typescale.headline.large);
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: function root(_ref10) {
          var theme = _ref10.theme;
          return {
            color: theme.sys.color.onSurfaceVariant
          };
        },
        labelContainer: function labelContainer(_ref11) {
          var theme = _ref11.theme;
          return _objectSpread2({}, theme.sys.typescale.label.large);
        },
        switchViewButton: function switchViewButton(_ref12) {
          var theme = _ref12.theme;
          return {
            color: theme.sys.color.onSurfaceVariant
          };
        }
      }
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: function weekDayLabel(_ref13) {
          var theme = _ref13.theme;
          return _objectSpread2({
            color: theme.sys.color.onSurface
          }, theme.sys.typescale.body.large);
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: function root(_ref14) {
          var theme = _ref14.theme;
          return _objectSpread2(_objectSpread2({
            color: theme.sys.color.onSurface
          }, theme.sys.typescale.body.large), {}, {
            '&.Mui-Selected, &.Mui-selected:hover, &.Mui-selected:focus': _objectSpread2(_objectSpread2({}, theme.sys.typescale.label.large), {}, {
              color: theme.sys.color.onPrimary,
              background: theme.sys.color.primary
            })
          });
        },
        today: function today(_ref15) {
          var theme = _ref15.theme;
          return {
            color: theme.sys.color.primary,
            '&:not(.Mui-selected)': {
              borderColor: theme.sys.color.primary
            }
          };
        }
      }
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: function yearButton(_ref16) {
          var theme = _ref16.theme;
          return _objectSpread2(_objectSpread2({
            color: theme.sys.color.onSurfaceVariant
          }, theme.sys.typescale.body.large), {}, {
            '&.Mui-Selected, &.Mui-selected:hover, &.Mui-selected:focus': _objectSpread2(_objectSpread2({}, theme.sys.typescale.title.medium), {}, {
              color: theme.sys.color.onPrimary,
              background: theme.sys.color.primary
            })
          });
        }
      }
    }
  };
}

// Assuming Theme might be needed, like in MuiCard

function getMuiPopoverTheme(mode, token) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: function paper(_ref) {
          _ref.theme;
          return _objectSpread2({
            background: token.sys.color.surfaceContainerLowest,
            boxShadow: token.sys.elevation[1],
            borderRadius: 4,
            color: token.sys.color.onSurface
          }, mode === 'dark' && {
            border: "2px solid ".concat(token.sys.color.outline)
          });
        }
      }
    }
  };
}

function getMuiProgressTheme(mode, token) {
  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          background: token.sys.color.surfaceContainerHighest
        }
      }
    }
  };
}

function getMuiSelectTheme(mode, token) {
  return {
    MuiSelect: {
      styleOverrides: {
        outlined: {
          color: token.sys.color.onSurface
        }
      }
    }
  };
}

function getMuiSliderTheme(mode, token) {
  return {
    MuiSlider: {
      styleOverrides: {
        rail: {
          background: token.sys.color.surfaceContainerHighest
        },
        mark: {
          Opacity: 0.38,
          background: token.sys.color.onSurfaceVariant
        },
        markActive: {
          background: token.sys.color.onPrimary
        },
        valueLabel: {
          lineHeight: 1.2,
          fontSize: 12,
          background: 'unset',
          padding: 0,
          width: 32,
          height: 32,
          borderRadius: '50% 50% 50% 0',
          transformOrigin: 'bottom left',
          transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
          color: token.sys.color.onPrimary,
          backgroundColor: token.sys.color.primary,
          '&:before': {
            display: 'none'
          },
          '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -100%) rotate(-45deg) scale(1)'
          },
          '& > *': {
            transform: 'rotate(45deg)'
          }
        }
      }
    }
  };
}

var getBgMixin = function getBgMixin(theme) {
  return function (_ref) {
    var color = _ref.color,
      opacity = _ref.opacity,
      overlayColor = _ref.overlayColor,
      borderGradient = _ref.borderGradient;
    return _objectSpread2({
      background: (overlayColor ? "linear-gradient(0deg, ".concat(overlayColor, " 0%, ").concat(overlayColor, " 100%), ") : '') + "".concat(hexColorWithOpacity(color, opacity)),
      backdropFilter: 'blur(32.5px)'
    }, theme.palette.mixins.gradientRadiusBorderOverlay({
      radius: 8,
      borderWidth: 1,
      borderGradient: borderGradient ? borderGradient : "linear-gradient(180deg, ".concat(hexColorWithOpacity(color, 0.7), " 0%, #00000000 100%)")
    }));
  };
};
function getMuiSnackbarTheme(mode) {
  return {
    MuiSnackbar: {
      styleOverrides: {
        // default
        root: function root(_ref2) {
          var theme = _ref2.theme;
          return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(paperClasses.root), _objectSpread2({
            padding: '4px 16px',
            boxShadow: theme.sys.elevation.glassLarge
          }, getBgMixin(theme)(mode === 'light' ? {
            color: theme.sys.ref.primary[50],
            opacity: 0.5,
            overlayColor: 'rgba(0, 0, 0, 0.40)'
          } : {
            color: theme.sys.ref.primary[50],
            opacity: 0.5,
            overlayColor: 'rgba(10, 13, 20, 0.40)'
          }))), ".".concat(snackbarContentClasses.message), _objectSpread2(_objectSpread2({}, theme.sys.typescale.body.medium), {}, {
            padding: 0,
            color: theme.sys.color.inverseOnSurface
          })), ".".concat(snackbarContentClasses.action), _defineProperty(_defineProperty({
            color: mode === 'light' ? theme.sys.ref.primary[70] : theme.sys.color.primary
          }, ".".concat(buttonClasses.root), {
            color: 'inherit',
            padding: '10px 12px'
          }), ".".concat(svgIconClasses.root), {
            color: theme.sys.color.inverseOnSurface
          })), '&.prewrap', _defineProperty({}, ".".concat(snackbarContentClasses.message), {
            whiteSpace: 'pre-wrap'
          })), '&.multiline', _defineProperty({}, ".".concat(paperClasses.root), {
            paddingTop: '14px',
            paddingBottom: '14px'
          })), '&.column', _defineProperty(_defineProperty({}, ".".concat(paperClasses.root), {
            flexDirection: 'column',
            alignItems: 'flex-start',
            paddingBottom: 0
          }), ".".concat(snackbarContentClasses.action), {
            marginTop: '14px'
          }));
        }
      },
      variants: [{
        props: {
          type: 'success'
        },
        style: function style(_ref4) {
          var theme = _ref4.theme;
          return _defineProperty(_defineProperty(_defineProperty({}, ".".concat(paperClasses.root), _objectSpread2({}, getBgMixin(theme)(mode === 'light' ? {
            color: theme.sys.ref.success[50],
            opacity: 0.5,
            overlayColor: 'rgba(0, 0, 0, 0.40)'
          } : {
            color: theme.sys.ref.success[70],
            opacity: 0.4,
            overlayColor: 'rgba(10, 13, 20, 0.40)'
          }))), ".".concat(snackbarContentClasses.message), {
            color: theme.sys.ref.success[99]
          }), ".".concat(snackbarContentClasses.action), {
            color: mode === 'light' ? theme.sys.color.inverseOnSurface : theme.sys.color.onSurface
          });
        }
      }, {
        props: {
          type: 'error'
        },
        style: function style(_ref6) {
          var theme = _ref6.theme;
          return _defineProperty(_defineProperty(_defineProperty({}, ".".concat(paperClasses.root), _objectSpread2({}, getBgMixin(theme)(mode === 'light' ? {
            color: theme.sys.ref.error[50],
            opacity: 0.6,
            overlayColor: 'rgba(0, 0, 0, 0.30)',
            // one-off colors supplied by UX to make border less bright
            borderGradient: "linear-gradient(180deg, #A72115 0%, #74160F 100%)"
          } : {
            color: theme.sys.ref.error[50],
            opacity: 0.5,
            overlayColor: 'rgba(10, 13, 20, 0.40)'
          }))), ".".concat(snackbarContentClasses.message), {
            color: theme.sys.ref.error[95]
          }), ".".concat(snackbarContentClasses.action), {
            color: theme.sys.color.inverseOnSurface
          });
        }
      }, {
        props: {
          type: 'warning'
        },
        style: function style(_ref8) {
          var theme = _ref8.theme;
          return _defineProperty(_defineProperty(_defineProperty({}, ".".concat(paperClasses.root), _objectSpread2({}, getBgMixin(theme)(mode === 'light' ? {
            color: theme.sys.ref.caution[50],
            opacity: 0.6,
            // one-off colors supplied by UX to make border less bright
            borderGradient: "linear-gradient(180deg, #B08128 0%, #CD932C 100%)"
          } : {
            color: theme.sys.ref.caution[70],
            opacity: 0.4,
            overlayColor: 'rgba(10, 13, 20, 0.40)'
          }))), ".".concat(snackbarContentClasses.message), {
            color: mode === 'light' ? theme.sys.ref.caution[10] : theme.sys.ref.caution[99]
          }), ".".concat(snackbarContentClasses.action), {
            color: theme.sys.color.onSurface
          });
        }
      }]
    }
  };
}

function getMuiSwitchTheme(mode, token) {
  return {
    MuiSwitch: {
      styleOverrides: {
        defaultProps: {
          disableRipple: true,
          focusVisibleClassName: '.Mui-focusVisible'
        },
        root: function root() {
          return {
            width: 52,
            height: 32,
            padding: 0,
            '& .MuiSwitch-switchBase': {
              padding: 0,
              width: 32,
              height: 32,
              transitionDuration: '300ms',
              '&.Mui-checked': {
                transform: 'translateX(20px)',
                color: token.palette.common.white,
                '.MuiSwitch-thumb': {
                  width: 24,
                  height: 24,
                  background: token.sys.color.onPrimary
                },
                '& + .MuiSwitch-track': {
                  background: token.sys.color.primary,
                  opacity: 1,
                  border: 0
                },
                '& .MuiSwitch-thumb-icon': {
                  background: token.sys.color.onPrimary,
                  '& .MuiSvgIcon-root': {
                    color: token.sys.color.onPrimaryContainer
                  }
                }
              },
              '&.Mui-disabled .MuiSwitch-thumb': {
                opacity: 0.3
              },
              '&.Mui-disabled .MuiSwitch-thumb-icon': {
                opacity: 0.3
              },
              '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.3
              }
            },
            '& .MuiSwitch-thumb': {
              boxSizing: 'border-box',
              width: 16,
              height: 16,
              boxShadow: 'none',
              background: token.sys.color.onSurfaceVariant,
              borderRadius: '50%'
            },
            '& .MuiSwitch-thumb-icon': {
              display: 'inline-flex',
              boxSizing: 'border-box',
              width: 24,
              height: 24,
              boxShadow: 'none',
              background: token.sys.color.onSurfaceVariant,
              borderRadius: '50%',
              alignItems: 'center',
              justifyContent: 'center',
              '& .MuiSvgIcon-root': {
                fontSize: '1rem',
                color: token.sys.color.onPrimary
              }
            },
            '& .MuiSwitch-track': {
              borderRadius: 32 / 2,
              opacity: 1,
              background: token.sys.color.surfaceContainerHighest,
              border: "2px solid ".concat(token.sys.color.primary)
            },
            '& :hover': {
              '& .MuiSwitch-thumb': {
                background: token.sys.color.onSurfaceVariant
              }
            },
            '& :active': {
              '& .MuiSwitch-thumb': {
                transform: 'scale(1.2)'
              },
              '& .MuiSwitch-thumb-icon': {
                transform: 'scale(1.2)'
              }
            }
          };
        }
      }
    }
  };
}

function getMuiTableTheme(mode, token) {
  return {
    MuiTable: {
      styleOverrides: {
        root: _defineProperty({}, ".".concat(tableRowClasses.root, " td"), {
          border: 'none'
        })
      }
    }
  };
}

function getMuiTabTheme(mode, token) {
  return {
    MuiTab: {
      styleOverrides: {
        root: _objectSpread2(_objectSpread2({
          textTransform: 'none',
          color: token.sys.color.onSurfaceVariant
        }, token.sys.typescale.title.small), {}, {
          minHeight: '48px'
        })
      }
    }
  };
}

function getMuiToggleButtonGroupTheme(mode, token) {
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: function root() {
          return _objectSpread2(_objectSpread2({
            borderRadius: '16px',
            borderColor: token.sys.color.outline,
            color: token.sys.color.onSurface,
            background: 'transparent'
          }, token.sys.typescale.label.large), {}, {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textTransform: 'capitalize',
            padding: '10px 12px',
            '> svg': {
              width: '18px',
              fontSize: '18px'
            },
            '&:hover': {
              backgroundColor: 'transparent',
              '&::after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.08'])
            },
            '&.Mui-disabled': {
              opacity: 0.38
            },
            '&.Mui-selected': {
              backgroundColor: mode === 'light' ? token.sys.ref.primary['85'] : token.sys.ref.primary['25'],
              color: token.sys.color.onSecondaryContainer,
              '&:hover': {
                backgroundColor: 'transparent',
                '&::after': generateStateLayerRules(token.stateLayer.onSecondaryContainer['opacity-0.08'])
              }
            }
          });
        }
      }
    }
  };
}

function getMuiTypographyTheme(token) {
  return {
    MuiTypography: {
      variants: [{
        props: {
          variant: 'h1'
        },
        style: function style(_ref) {
          var theme = _ref.theme;
          return {
            fontSize: '40px',
            color: theme.palette.text.primary,
            fontWeight: 600,
            lineHeight: '150%',
            display: 'flex',
            alignItems: 'center',
            letterSpacing: '-0.011em',
            ':hover': {
              letterSpacing: '0'
            }
          };
        }
      }, {
        props: {
          variant: 'h2'
        },
        style: function style(_ref2) {
          var theme = _ref2.theme;
          return _objectSpread2(_objectSpread2({}, theme.sys.typescale.headline.medium), {}, {
            color: theme.sys.color.primary
          });
        }
      }, {
        props: {
          variant: 'caption'
        },
        style: function style(_ref3) {
          var theme = _ref3.theme;
          return _objectSpread2(_objectSpread2({}, theme.sys.typescale.label.medium), {}, {
            color: theme.sys.color.onSurface
          });
        }
      }]
    }
  };
}

function getMuiTooltipTheme(mode, theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          background: mode === 'light' ? theme.sys.color.inverseSurface : theme.sys.color.inverseOnSurface,
          color: mode === 'light' ? theme.sys.color.inverseOnSurface : theme.sys.color.inverseSurface,
          borderRadius: '4px',
          fontSize: '12px'
        },
        arrow: {
          color: mode === 'light' ? theme.sys.color.inverseSurface : theme.sys.color.inverseOnSurface
        }
      }
    }
  };
}

var componentStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getMuiAutocompletePopperTheme: getMuiAutocompletePopperTheme,
  getMuiBadgeTheme: getMuiBadgeTheme,
  getMuiButtonTheme: getMuiButtonTheme,
  getMuiCardTheme: getMuiCardTheme,
  getMuiCheckboxTheme: getMuiCheckboxTheme,
  getMuiChipTheme: getMuiChipTheme,
  getMuiDialogTheme: getMuiDialogTheme,
  getMuiDividerTheme: getMuiDividerTheme,
  getMuiDrawerTheme: getMuiDrawerTheme,
  getMuiFabTheme: getMuiFabTheme,
  getMuiIconButtonTheme: getMuiIconButtonTheme,
  getMuiInputTheme: getMuiInputTheme,
  getMuiListTheme: getMuiListTheme,
  getMuiMenuTheme: getMuiMenuTheme,
  getMuiNavigationTheme: getMuiNavigationTheme,
  getMuiPickersPopperTheme: getMuiPickersPopperTheme,
  getMuiPickersTheme: getMuiPickersTheme,
  getMuiPopoverTheme: getMuiPopoverTheme,
  getMuiProgressTheme: getMuiProgressTheme,
  getMuiSelectTheme: getMuiSelectTheme,
  getMuiSliderTheme: getMuiSliderTheme,
  getMuiSnackbarTheme: getMuiSnackbarTheme,
  getMuiSwitchTheme: getMuiSwitchTheme,
  getMuiTableTheme: getMuiTableTheme,
  getMuiTabTheme: getMuiTabTheme,
  getMuiToggleButtonGroupTheme: getMuiToggleButtonGroupTheme,
  getMuiTypographyTheme: getMuiTypographyTheme,
  getMuiTooltipTheme: getMuiTooltipTheme
});

var ebTheme = function ebTheme(mode) {
  var token = transformTokenToTheme(mode);
  var components = reduce(componentStyles, function (style, getStyle) {
    return _objectSpread2(_objectSpread2({}, style), getStyle(mode, token));
  }, {});
  // @ts-ignore
  return createTheme(_objectSpread2(_objectSpread2({}, token), {}, {
    components: components
  }));
};

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

var _excluded$3 = ["children"];
var Card = function Card(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/jsx(Card$1, _objectSpread2(_objectSpread2({}, rest), {}, {
    children: children
  }));
};

var _excluded$2 = ["label"];
var Button = function Button(_ref) {
  var label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/jsx(Button$1, _objectSpread2(_objectSpread2({}, rest), {}, {
    children: label
  }));
};

var _excluded$1 = ["label"];
var AnimatedButton$1 = animated(Chip$1);
var Chip = function Chip(_ref) {
  var label = _ref.label,
    chipProps = _objectWithoutProperties(_ref, _excluded$1);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  useTheme();
  var activeSpring = useSpring({
    config: config.stiff
  });
  return /*#__PURE__*/jsx(AnimatedButton$1, _objectSpread2({
    label: label,
    style: activeSpring,
    deleteIcon: /*#__PURE__*/jsx(ClearIcon, {})
  }, chipProps));
};

function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var Dialog = function Dialog(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/jsx(Dialog$1, _objectSpread2({}, rest));
};

var EbStaticDatePicker = styled(StaticDatePicker)(function (_ref) {
  var theme = _ref.theme;
  return {
    borderRadius: 12,
    background: token.M3.sys[theme.palette.mode].surfaceContainer.value
  };
});

var EbStaticTimePicker = styled(StaticTimePicker)(function (_ref) {
  var theme = _ref.theme;
  return _objectSpread2(_objectSpread2({
    borderRadius: 28,
    background: theme.sys.color.surfaceContainer
  }, borderRules(1, theme.sys.color.outline)), {}, {
    '& .MuiPickersLayout-landscape': {}
  });
});

var Fab = function Fab(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/jsx(Fab$1, _objectSpread2({}, rest));
};

var IconButton = function IconButton(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/jsx(IconButton$1, _objectSpread2({}, rest));
};

var _excluded = ["label", "onDelete", "active"];
var AnimatedButton = animated(Chip$1);
var RippleChip = function RippleChip(_ref) {
  var label = _ref.label;
    _ref.onDelete;
    var active = _ref.active,
    chipProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var theme = useTheme();
  var activeSpring = useSpring({
    // scale: active ? 1.00 : 0.9,
    background: active ? '#3A00A7' : 'transparent',
    config: config.stiff
  });
  return (
    /*#__PURE__*/
    // <ButtonBase
    //     onFocus={handleFocus}
    //     onBlur={handleBlur}
    // >
    // {focus && <TouchRipple />}
    jsx(AnimatedButton, _objectSpread2(_objectSpread2({
      sx: {
        margin: 0,
        // M3/sys/dark/outlineVariant
        // borderColor: theme.sys.color.outlineVariant,
        '::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: '0.5rem',
          padding: '1px' /* control the border thickness */,
          background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.16) 100%)',
          mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          maskComposite: 'exclude'
        },
        '&:hover::before': {
          content: '""',
          padding: '0px'
        },
        '&:focus::before': {
          content: '""',
          padding: '0px'
        },
        border: 'none',
        // theme.sys.ref.secondary[40]
        // background: active ? "#3A00A7" : "transparent",
        // M3/sys/dark/onSecondaryContainer
        color: theme.sys.color.onSecondaryContainer,
        '&:focus': {
          background: theme.sys.color.secondaryContainer,
          border: 'none'
        }
      },
      label: label
    }, chipProps), {}, {
      style: activeSpring
    }))
  );
};

export { Button, Card, Chip, Dialog, EbStaticDatePicker, EbStaticTimePicker, Fab, IconButton, RippleChip, ebTheme as default };
